import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule, Optional, EventEmitter, ElementRef, Output, ViewChild, ViewEncapsulation, ChangeDetectorRef, Injectable, Inject, inject, HostBinding, DestroyRef, signal, Directive } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { colors, GoogleMap, isNil, getTrailsColor } from '@helsana/shared-maps-utils';
import * as i8 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i3 from '@angular/forms';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import * as i4 from '@ngneat/transloco';
import { isString, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i6 from '@angular/material/autocomplete';
import { MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import { startWith, map, ReplaySubject, tap, catchError, of, Subject, combineLatest } from 'rxjs';
import * as i2 from '@angular/material/form-field';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import * as i7 from '@angular/material/core';
import * as i5$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMaskDirective } from 'ngx-mask';
import { __decorate, __metadata } from 'tslib';
import * as i5$2 from '@angular/material/select';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import * as i7$1 from 'ngx-mat-select-search';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import * as i2$1 from '@angular/google-maps';
import { GoogleMapsModule } from '@angular/google-maps';
import * as i1$1 from '@angular/common/http';
import * as d3 from 'd3';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TrailType } from '@helsana/data-access';

var TitleSize;
(function (TitleSize) {
    TitleSize["XXS"] = "12px";
    TitleSize["XS"] = "14px";
    TitleSize["S"] = "16px";
    TitleSize["M"] = "20px";
    TitleSize["L"] = "24px";
})(TitleSize || (TitleSize = {}));
var TitleType;
(function (TitleType) {
    TitleType["H1"] = "h1";
    TitleType["H2"] = "h2";
    TitleType["H3"] = "h3";
    TitleType["H4"] = "h4";
    TitleType["H5"] = "h5";
    TitleType["H6"] = "h6";
})(TitleType || (TitleType = {}));

class TitleComponent {
    constructor() {
        this.bold = false;
        this.color = 'black';
        this.title = '';
        this.size = TitleSize.M;
        this.truncate = false;
        this.colors = colors;
        this.TitleType = TitleType;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: TitleComponent, isStandalone: true, selector: "shared-maps-ui-title", inputs: { bold: "bold", color: "color", title: "title", type: "type", size: "size", truncate: "truncate" }, ngImport: i0, template: "@if(type === TitleType.H1) {\n<h1\n  class=\"t-h1\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h1>\n} @if (type === TitleType.H2) {\n<h2\n  class=\"t-h2\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h2>\n} @if(type === TitleType.H3) {\n<h3\n  class=\"t-h3\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h3>\n} @if(type === TitleType.H4) {\n<h4\n  class=\"t-h4\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h4>\n} @if(type === TitleType.H5) {\n<h5\n  class=\"t-h5\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h5>\n} @if(type === TitleType.H6) {\n<h6\n  class=\"t-h6\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h6>\n}\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-title', standalone: true, imports: [CommonModule], changeDetection: ChangeDetectionStrategy.OnPush, template: "@if(type === TitleType.H1) {\n<h1\n  class=\"t-h1\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h1>\n} @if (type === TitleType.H2) {\n<h2\n  class=\"t-h2\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h2>\n} @if(type === TitleType.H3) {\n<h3\n  class=\"t-h3\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h3>\n} @if(type === TitleType.H4) {\n<h4\n  class=\"t-h4\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h4>\n} @if(type === TitleType.H5) {\n<h5\n  class=\"t-h5\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h5>\n} @if(type === TitleType.H6) {\n<h6\n  class=\"t-h6\"\n  [style.font-size]=\"size\"\n  [style.font-family]=\"\n    bold\n      ? 'AkkuratHelsanaTT-Bold Web, sans-serif'\n      : 'AkkuratHelsanaTT Regular Web, sans-serif'\n  \"\n  [ngClass]=\"{ 'font-bold': bold, 'font-normal': !bold, truncate: truncate }\"\n  [style.color]=\"colors[color]\"\n>\n  {{ title }}\n</h6>\n}\n" }]
        }], propDecorators: { bold: [{
                type: Input
            }], color: [{
                type: Input
            }], title: [{
                type: Input
            }], type: [{
                type: Input,
                args: [{ required: true }]
            }], size: [{
                type: Input
            }], truncate: [{
                type: Input
            }] } });

class LabelComponent {
    constructor() {
        this.bold = false;
        this.normal = false;
        this.small = false;
        this.color = 'black';
        this.size = TitleSize.XS;
        this.colors = colors;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: LabelComponent, isStandalone: true, selector: "shared-maps-ui-label", inputs: { bold: "bold", normal: "normal", small: "small", color: "color", size: "size" }, ngImport: i0, template: "<span\n  [style.color]=\"colors[color]\"\n  [style.font-size]=\"size\"\n  [style.align-items]=\"'normal'\"\n  [ngClass]=\"{\n    't-label-bold': bold,\n    't-label-normal': normal,\n    't-label-small': small\n  }\"\n  class=\"flex\"\n>\n  <ng-content></ng-content>\n</span>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-label', standalone: true, imports: [CommonModule], changeDetection: ChangeDetectionStrategy.OnPush, template: "<span\n  [style.color]=\"colors[color]\"\n  [style.font-size]=\"size\"\n  [style.align-items]=\"'normal'\"\n  [ngClass]=\"{\n    't-label-bold': bold,\n    't-label-normal': normal,\n    't-label-small': small\n  }\"\n  class=\"flex\"\n>\n  <ng-content></ng-content>\n</span>\n" }]
        }], propDecorators: { bold: [{
                type: Input
            }], normal: [{
                type: Input
            }], small: [{
                type: Input
            }], color: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class LinkWrapperComponent {
    constructor() {
        this.text = '';
        this.href = '';
        this.target = '_self';
        this.color = 'helsana';
        this.preventEvent = false;
        this.isDownload = false;
        this.colors = colors;
    }
    onClick(event) {
        if (this.preventEvent) {
            event.preventDefault();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LinkWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: LinkWrapperComponent, isStandalone: true, selector: "shared-maps-ui-link-wrapper", inputs: { text: "text", href: "href", target: "target", color: "color", preventEvent: "preventEvent", isDownload: "isDownload" }, ngImport: i0, template: "<a\n  (click)=\"onClick($event)\"\n  title=\"{{ text }}\"\n  [attr.aria-label]=\"text\"\n  [style.color]=\"colors[color]\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [attr.download]=\"isDownload ? true : null\"\n>\n  <ng-content></ng-content>\n</a>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LinkWrapperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-link-wrapper', standalone: true, imports: [CommonModule], template: "<a\n  (click)=\"onClick($event)\"\n  title=\"{{ text }}\"\n  [attr.aria-label]=\"text\"\n  [style.color]=\"colors[color]\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [attr.download]=\"isDownload ? true : null\"\n>\n  <ng-content></ng-content>\n</a>\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], href: [{
                type: Input
            }], target: [{
                type: Input
            }], color: [{
                type: Input
            }], preventEvent: [{
                type: Input
            }], isDownload: [{
                type: Input
            }] } });

const appearance = {
    appearance: 'outline',
    hideRequiredMarker: true,
    subscriptSizing: 'dynamic',
};
/**
 * When imported to module mat-form-field gets outlined style & more
 */
class FormFieldOutlinedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: FormFieldOutlinedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.3", ngImport: i0, type: FormFieldOutlinedModule, exports: [MatFormFieldModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: FormFieldOutlinedModule, providers: [
            {
                provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
                useValue: appearance,
            },
        ], imports: [MatFormFieldModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: FormFieldOutlinedModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
                            useValue: appearance,
                        },
                    ],
                    exports: [MatFormFieldModule],
                }]
        }] });

/* eslint-disable @typescript-eslint/no-explicit-any */
class UiFormBaseComponent {
    constructor(ref) {
        this.ref = ref;
        this.label = '';
        this.placeholder = '';
        this.errorLabels = {};
        this.slim = false;
        this.disabled = false;
        this.markAsTouchedProxyRegistered = false;
    }
    set value(value) {
        this.control.setValue(value);
    }
    get value() {
        return this.control.getRawValue();
    }
    get formControl() {
        if (!this.control) {
            console.error(`no control given for ${this.label}`);
        }
        // TODO find nicer solution to manually trigger change detection when form control gets touched programmatically
        // workaround as there is no way to get an event when field gets marked as touched
        // context: https://github.com/angular/angular/issues/10887
        if (!!this.control?.markAsTouched && !this.markAsTouchedProxyRegistered) {
            this.markAsTouchedProxyRegistered = true;
            this.registerMarkAsTouchedProxy();
        }
        return this.control;
    }
    get hasError() {
        return (this.formControl?.touched &&
            !this.formControl?.disabled &&
            !this.formControl?.valid);
    }
    nextErrorLabel() {
        const errorKey = this.errorKey();
        return this.errorLabels[errorKey] || `error.${errorKey}`;
    }
    nextError() {
        return (this.formControl?.errors ?? {})[this.errorKey()];
    }
    errorKey() {
        return Object.keys(this.formControl?.errors ?? {})[0];
    }
    registerMarkAsTouchedProxy() {
        if (!this.formControl.markAsTouched) {
            return;
        }
        const originalMarkAsTouchedFnc = this.formControl.markAsTouched;
        const markAsTouchedHandler = {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            apply: (target, thisArg, argumentsList) => {
                setTimeout(() => this.ref.detectChanges());
                return Reflect.apply(target, thisArg, argumentsList);
            },
        };
        this.formControl.markAsTouched = new Proxy(originalMarkAsTouchedFnc, markAsTouchedHandler);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiFormBaseComponent, deps: [{ token: i0.ChangeDetectorRef, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: UiFormBaseComponent, isStandalone: true, selector: "shared-maps-ui-form-base", inputs: { control: "control", label: "label", placeholder: "placeholder", hintLabel: "hintLabel", errorLabels: "errorLabels", slim: "slim", disabled: "disabled" }, ngImport: i0, template: '', isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiFormBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'shared-maps-ui-form-base',
                    standalone: true,
                    imports: [CommonModule],
                    template: '',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef, decorators: [{
                    type: Optional
                }] }], propDecorators: { control: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], hintLabel: [{
                type: Input
            }], errorLabels: [{
                type: Input
            }], slim: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

const fixMaterialLabelOnFocus = (matLabel) => {
    const parent = matLabel.nativeElement.parentElement?.parentElement;
    const interval = setInterval(() => {
        const isInlineStlyeWidthSet = !!parent?.style?.getPropertyValue('width')?.length;
        if (isInlineStlyeWidthSet) {
            const calculatedWidth = getCalculatedCssLabelWidth(getLabelOffsetWidth(matLabel));
            setWidth(parent, calculatedWidth);
        }
        clearInterval(interval);
        clearIntervalWithTimeout(interval, 1000);
    });
};
const fixMaterialLabel = (matLabel) => {
    const element = matLabel.nativeElement.parentElement?.parentElement;
    // call interval until width is set or timeout of X seconds is reached
    const interval = setInterval(() => {
        const isInlineStlyeWidthSet = !!element?.style?.getPropertyValue('width')?.length;
        if (isInlineStlyeWidthSet) {
            const calculatedWidth = getCalculatedCssLabelWidth(getLabelOffsetWidth(matLabel));
            setWidth(element, calculatedWidth);
            clearInterval(interval);
        }
    });
    clearIntervalWithTimeout(interval, 3000);
};
const clearIntervalWithTimeout = (interval, timeout) => {
    const timeOut = setTimeout(() => {
        clearInterval(interval);
        clearTimeout(timeOut);
    }, timeout);
};
const setWidth = (elem, width) => {
    elem.style.setProperty('width', width);
};
const getLabelOffsetWidth = (matLabel) => {
    return matLabel.nativeElement.offsetWidth;
};
const getCalculatedCssLabelWidth = (multiplierInPx) => `calc( ${multiplierInPx}px * var(--mat-mdc-form-field-floating-label-scale, 0.75) + 9px)`;

class UiAutocompleteComponent extends UiFormBaseComponent {
    constructor(ref) {
        super(ref);
        this.options = [];
        this.focus = false;
        this.hasDivide = true;
        this.blurred = new EventEmitter();
        this.optionSelected = new EventEmitter();
    }
    ngOnInit() {
        this.filteredOptions$ = this.formControl.valueChanges.pipe(startWith(''), map((value) => {
            return value ? this.filter(value) : this.options.slice();
        }));
    }
    getOptionLabel(value) {
        return isString(value)
            ? value
            : this.options.filter((option) => option.value === value).at(0)?.label ??
                '';
    }
    selectFirstOption(emitEvent = true) {
        this.inputAutoComplete?.autocomplete.options?.first?.select(emitEvent);
        this.inputAutoComplete?.closePanel();
    }
    focusEvents() {
        this.fixMaterialLabelOnFocus();
    }
    /**
     *  This is a workaround for the issue that the mat-label width is not set correctly inside AEM
     */
    fixMaterialLabelOnFocus() {
        this.inputAutoComplete?.openPanel();
        fixMaterialLabelOnFocus(this.matLabel);
    }
    opened() {
        this.inputAutoComplete?.openPanel();
    }
    onOptionSelected(event) {
        this.optionSelected.emit(event.option.value);
    }
    filter(value) {
        const filterValue = value.toLowerCase();
        return this.options.filter((option) => option.label.toLowerCase().includes(filterValue));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiAutocompleteComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: UiAutocompleteComponent, isStandalone: true, selector: "shared-maps-ui-autocomplete", inputs: { options: "options", focus: "focus", hasDivide: "hasDivide" }, outputs: { blurred: "blurred", optionSelected: "optionSelected" }, viewQueries: [{ propertyName: "matLabel", first: true, predicate: ["matLabel"], descendants: true }, { propertyName: "inputAutoComplete", first: true, predicate: MatAutocompleteTrigger, descendants: true, read: MatAutocompleteTrigger }, { propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true, read: ElementRef }], usesInheritance: true, ngImport: i0, template: "<mat-form-field *transloco=\"let t\">\n  <mat-label #matLabel>{{ label }}</mat-label>\n  <input\n    #inputElement\n    #inputAutoComplete\n    matInput\n    (focus)=\"focusEvents()\"\n    (blur)=\"blurred.emit()\"\n    [placeholder]=\"placeholder\"\n    [formControl]=\"formControl\"\n    [matAutocomplete]=\"autoComplete\"\n    [cdkTrapFocus]=\"focus\"\n    [cdkTrapFocusAutoCapture]=\"focus\"\n  />\n  <mat-autocomplete\n    #autoComplete=\"matAutocomplete\"\n    [displayWith]=\"getOptionLabel.bind(this)\"\n    (opened)=\"opened()\"\n    (optionSelected)=\"onOptionSelected($event)\"\n    autoActiveFirstOption\n  >\n    <mat-option [ngClass]=\"{'border-gray-200 border-b': hasDivide }\" *ngFor=\"let option of options\" [value]=\"option.value\">\n      {{ option.label }}\n    </mat-option>\n  </mat-autocomplete>\n  <div matSuffix>\n    <ng-content select=\".suffix\"></ng-content>\n  </div>\n  <mat-error *ngIf=\"hasError\">{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n  <mat-hint *ngIf=\"hintLabel\">{{ hintLabel }}</mat-hint>\n</mat-form-field>\n", styles: [":host{--mat-form-field-container-text-line-height: 1.5}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FormFieldOutlinedModule }, { kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2.MatLabel, selector: "mat-label" }, { kind: "directive", type: i2.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i2.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "directive", type: i2.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i4.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: MatButtonModule }, { kind: "ngmodule", type: MatButtonToggleModule }, { kind: "ngmodule", type: MatInputModule }, { kind: "directive", type: i5.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "ngmodule", type: MatAutocompleteModule }, { kind: "component", type: i6.MatAutocomplete, selector: "mat-autocomplete", inputs: ["aria-label", "aria-labelledby", "displayWith", "autoActiveFirstOption", "autoSelectActiveOption", "requireSelection", "panelWidth", "disableRipple", "class", "hideSingleSelectionIndicator"], outputs: ["optionSelected", "opened", "closed", "optionActivated"], exportAs: ["matAutocomplete"] }, { kind: "component", type: i7.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "directive", type: i6.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", inputs: ["matAutocomplete", "matAutocompletePosition", "matAutocompleteConnectedTo", "autocomplete", "matAutocompleteDisabled"], exportAs: ["matAutocompleteTrigger"] }, { kind: "ngmodule", type: A11yModule }, { kind: "directive", type: i8.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-autocomplete', standalone: true, imports: [
                        CommonModule,
                        FormFieldOutlinedModule,
                        ReactiveFormsModule,
                        TranslocoModule,
                        MatButtonModule,
                        MatButtonToggleModule,
                        MatInputModule,
                        MatAutocompleteModule,
                        A11yModule,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-form-field *transloco=\"let t\">\n  <mat-label #matLabel>{{ label }}</mat-label>\n  <input\n    #inputElement\n    #inputAutoComplete\n    matInput\n    (focus)=\"focusEvents()\"\n    (blur)=\"blurred.emit()\"\n    [placeholder]=\"placeholder\"\n    [formControl]=\"formControl\"\n    [matAutocomplete]=\"autoComplete\"\n    [cdkTrapFocus]=\"focus\"\n    [cdkTrapFocusAutoCapture]=\"focus\"\n  />\n  <mat-autocomplete\n    #autoComplete=\"matAutocomplete\"\n    [displayWith]=\"getOptionLabel.bind(this)\"\n    (opened)=\"opened()\"\n    (optionSelected)=\"onOptionSelected($event)\"\n    autoActiveFirstOption\n  >\n    <mat-option [ngClass]=\"{'border-gray-200 border-b': hasDivide }\" *ngFor=\"let option of options\" [value]=\"option.value\">\n      {{ option.label }}\n    </mat-option>\n  </mat-autocomplete>\n  <div matSuffix>\n    <ng-content select=\".suffix\"></ng-content>\n  </div>\n  <mat-error *ngIf=\"hasError\">{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n  <mat-hint *ngIf=\"hintLabel\">{{ hintLabel }}</mat-hint>\n</mat-form-field>\n", styles: [":host{--mat-form-field-container-text-line-height: 1.5}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { options: [{
                type: Input
            }], focus: [{
                type: Input
            }], hasDivide: [{
                type: Input
            }], blurred: [{
                type: Output
            }], optionSelected: [{
                type: Output
            }], matLabel: [{
                type: ViewChild,
                args: ['matLabel']
            }], inputAutoComplete: [{
                type: ViewChild,
                args: [MatAutocompleteTrigger, { read: MatAutocompleteTrigger }]
            }], inputElement: [{
                type: ViewChild,
                args: ['inputElement', { read: ElementRef }]
            }] } });

class UiCheckboxComponent extends UiFormBaseComponent {
    constructor(ref) {
        super(ref);
        this.fullWidth = true;
        this.id = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiCheckboxComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: UiCheckboxComponent, isStandalone: true, selector: "shared-maps-ui-checkbox", inputs: { fullWidth: "fullWidth", id: "id" }, usesInheritance: true, ngImport: i0, template: "<span\n  [ngClass]=\"{ 'full-width': fullWidth }\"\n  class=\"helsana-ui-checkbox-container mat-form-field-like\"\n  *transloco=\"let t\"\n>\n  <mat-checkbox min-height=\"43px\" [id]=\"id\" [formControl]=\"formControl\" [ngClass]=\"{ 'has-error': hasError }\" #matCheckbox>\n    {{ label }}\n    <ng-content></ng-content>\n  </mat-checkbox>\n  <mat-error *ngIf=\"hasError\">{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n</span>\n", styles: ["helsana-ui-checkbox .helsana-ui-checkbox-container{margin-left:-.5rem;padding-bottom:.5rem}helsana-ui-checkbox .helsana-ui-checkbox-container.full-width{width:calc(100% + .5rem)}helsana-ui-checkbox .mdc-form-field{width:100%;align-items:flex-start;vertical-align:text-bottom}helsana-ui-checkbox .mdc-form-field>label{margin-top:.5rem;width:100%;padding-left:0}helsana-ui-checkbox .mat-mdc-form-field-error{margin-top:-5px!important;padding-left:18px}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: MatInputModule }, { kind: "directive", type: i2.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "ngmodule", type: FormFieldOutlinedModule }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i4.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: MatCheckboxModule }, { kind: "component", type: i5$1.MatCheckbox, selector: "mat-checkbox", inputs: ["aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "disableRipple", "tabIndex", "color", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-checkbox', standalone: true, imports: [
                        CommonModule,
                        MatInputModule,
                        FormFieldOutlinedModule,
                        ReactiveFormsModule,
                        TranslocoModule,
                        MatCheckboxModule,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<span\n  [ngClass]=\"{ 'full-width': fullWidth }\"\n  class=\"helsana-ui-checkbox-container mat-form-field-like\"\n  *transloco=\"let t\"\n>\n  <mat-checkbox min-height=\"43px\" [id]=\"id\" [formControl]=\"formControl\" [ngClass]=\"{ 'has-error': hasError }\" #matCheckbox>\n    {{ label }}\n    <ng-content></ng-content>\n  </mat-checkbox>\n  <mat-error *ngIf=\"hasError\">{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n</span>\n", styles: ["helsana-ui-checkbox .helsana-ui-checkbox-container{margin-left:-.5rem;padding-bottom:.5rem}helsana-ui-checkbox .helsana-ui-checkbox-container.full-width{width:calc(100% + .5rem)}helsana-ui-checkbox .mdc-form-field{width:100%;align-items:flex-start;vertical-align:text-bottom}helsana-ui-checkbox .mdc-form-field>label{margin-top:.5rem;width:100%;padding-left:0}helsana-ui-checkbox .mat-mdc-form-field-error{margin-top:-5px!important;padding-left:18px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { fullWidth: [{
                type: Input
            }], id: [{
                type: Input
            }] } });

class UiInputComponent extends UiFormBaseComponent {
    constructor(ref) {
        super(ref);
        this.mask = '(000) 000-0000';
        this.prefix = '+3';
        this.blurred = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiInputComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: UiInputComponent, isStandalone: true, selector: "shared-maps-ui-input", inputs: { mask: "mask", prefix: "prefix" }, outputs: { blurred: "blurred" }, usesInheritance: true, ngImport: i0, template: "<mat-form-field *transloco=\"let t\">\n  <mat-label>{{ label }}</mat-label>\n  <input\n    matInput\n    [formControl]=\"formControl\"\n    [placeholder]=\"placeholder\"\n    (blur)=\"blurred.emit(formControl)\"\n  />\n  <ng-content select=\".suffix\"></ng-content>\n  <mat-error *ngIf=\"hasError\">{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n  <mat-hint *ngIf=\"hintLabel\">{{ hintLabel }}</mat-hint>\n</mat-form-field>\n", styles: [":host{--mdc-typography-body1-line-height: 1.5}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: MatInputModule }, { kind: "directive", type: i5.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2.MatLabel, selector: "mat-label" }, { kind: "directive", type: i2.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i2.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "ngmodule", type: FormFieldOutlinedModule }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i4.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: MatButtonModule }, { kind: "ngmodule", type: MatButtonToggleModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-input', standalone: true, imports: [
                        CommonModule,
                        MatInputModule,
                        FormFieldOutlinedModule,
                        ReactiveFormsModule,
                        TranslocoModule,
                        MatButtonModule,
                        MatButtonToggleModule,
                        NgxMaskDirective,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-form-field *transloco=\"let t\">\n  <mat-label>{{ label }}</mat-label>\n  <input\n    matInput\n    [formControl]=\"formControl\"\n    [placeholder]=\"placeholder\"\n    (blur)=\"blurred.emit(formControl)\"\n  />\n  <ng-content select=\".suffix\"></ng-content>\n  <mat-error *ngIf=\"hasError\">{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n  <mat-hint *ngIf=\"hintLabel\">{{ hintLabel }}</mat-hint>\n</mat-form-field>\n", styles: [":host{--mdc-typography-body1-line-height: 1.5}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { mask: [{
                type: Input
            }], prefix: [{
                type: Input
            }], blurred: [{
                type: Output
            }] } });

class UiOverlayHeaderComponent {
    constructor() {
        this.closeEvent = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiOverlayHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: UiOverlayHeaderComponent, isStandalone: true, selector: "shared-maps-ui-overlay-header", inputs: { title: "title" }, outputs: { closeEvent: "closeEvent" }, ngImport: i0, template: `
    <div class="flex items-center justify-between">
      <h2 class="t-h2">{{ title }}</h2>
      <button class="close-x" (click)="closeEvent.emit()">
        <div class="ico--close ico--20"></div>
      </button>
    </div>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiOverlayHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-overlay-header', standalone: true, imports: [CommonModule], template: `
    <div class="flex items-center justify-between">
      <h2 class="t-h2">{{ title }}</h2>
      <button class="close-x" (click)="closeEvent.emit()">
        <div class="ico--close ico--20"></div>
      </button>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush }]
        }], propDecorators: { title: [{
                type: Input
            }], closeEvent: [{
                type: Output
            }] } });

let UiSelectComponent = class UiSelectComponent extends UiFormBaseComponent {
    constructor(ref) {
        super(ref);
        this.options = [];
        this.withSearchField = false;
        this.floatLabel = 'always';
        this.isPanelOpen = false;
        this.selectPlaceholder = '';
        this.searchFilterCtrl = new FormControl('');
        this.filteredOptions = new ReplaySubject();
    }
    ngOnInit() {
        this.currentSelected = this.getSelectedOption(this.value) ?? undefined;
        this.handleOverlayCloseInsideAEM();
        this.filteredOptions.next(this.options);
        this.searchFilterCtrl.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(() => {
            this.getFilteredSelection();
        });
        this.control.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            this.currentSelected = this.getSelectedOption(value) ?? undefined;
        });
    }
    ngAfterViewInit() {
        this.fixMaterialLabel();
    }
    ngOnChanges(changes) {
        this.filteredOptions.next(changes['options'].currentValue);
        this.selectPlaceholder = this.getPlaceholder();
    }
    handleOnSelectChange(event) {
        this.currentSelected = this.getSelectedOption(event.value) ?? undefined;
    }
    handleOnOpenedChange(isPanelOpen) {
        this.isPanelOpen = isPanelOpen;
        this.fixMaterialLabelOnFocus();
    }
    /**
     * This is a workaround for the issue that the mat-label width is not set correctly inside AEM
     */
    fixMaterialLabelOnFocus() {
        fixMaterialLabelOnFocus(this.matLabel);
    }
    /**
     * This is a workaround for the issue that the mat-label width is not set correctly inside AEM
     */
    fixMaterialLabel() {
        fixMaterialLabel(this.matLabel);
    }
    getFilteredSelection() {
        if (!this.options) {
            return;
        }
        let search = this.searchFilterCtrl.value;
        if (!search) {
            this.filteredOptions.next(this.options.slice());
            return;
        }
        else {
            search = search.toLowerCase();
        }
        this.filteredOptions.next(this.options.filter((option) => search &&
            option.label &&
            option.label.toLowerCase().indexOf(search) > -1));
    }
    getSelectedOption(idx) {
        return this.options.find((option) => option.value === idx);
    }
    /**
     * This is a workaround for the issue that the mat-select overlay is not closed inside AEM
     */
    handleOverlayCloseInsideAEM() {
        document.addEventListener('click', (event) => {
            const element = event.target;
            const isSearchInput = element.classList.contains('mat-select-search-input');
            if (this.isPanelOpen && !isSearchInput) {
                this.matSelect.close();
            }
        });
    }
    getPlaceholder() {
        return this.options.length > 0
            ? this.placeholder
            : this.noOptionsPlaceholder ?? '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiSelectComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: UiSelectComponent, isStandalone: true, selector: "shared-maps-ui-select", inputs: { options: "options", withSearchField: "withSearchField", floatLabel: "floatLabel", noOptionsPlaceholder: "noOptionsPlaceholder" }, viewQueries: [{ propertyName: "matLabel", first: true, predicate: ["matLabel"], descendants: true }, { propertyName: "matSelect", first: true, predicate: MatSelect, descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<mat-form-field\n  *transloco=\"let t\"\n  [ngClass]=\"{ slim: slim }\"\n  [floatLabel]=\"floatLabel\"\n>\n  <mat-label #matLabel>{{ t(label) }}</mat-label>\n  <mat-select\n    [formControl]=\"control\"\n    [(value)]=\"value\"\n    (openedChange)=\"handleOnOpenedChange($event)\"\n    (selectionChange)=\"handleOnSelectChange($event)\"\n    [placeholder]=\"selectPlaceholder\"\n    class=\"shared-ui-select\"\n  >\n    <mat-select-trigger *ngIf=\"currentSelected\" class=\"shared-ui-select__item\">\n      <i\n        [class]=\"\n          'shared-ui-select__item-icon ' +\n          ' ico--' +\n          currentSelected.icon +\n          ' ico--24'\n        \"\n      ></i>\n      <span class=\"shared-ui-select__item-text\">{{\n        t(currentSelected.label || '')\n      }}</span>\n    </mat-select-trigger>\n\n    <!--   shared-ui-select__search -->\n    <mat-option class=\"shared-ui-select__search\" *ngIf=\"withSearchField\">\n      <mat-icon class=\"shared-ui-select__search-icon\" ngxMatSelectSearchClear\n        ><i class=\"ico--search ico--24\"></i\n      ></mat-icon>\n      <ngx-mat-select-search\n        class=\"shared-ui-select__search-text\"\n        [placeholderLabel]=\"label\"\n        [formControl]=\"searchFilterCtrl\"\n        [preventHomeEndKeyPropagation]=\"true\"\n      >\n      </ngx-mat-select-search>\n    </mat-option>\n\n    <!-- shared-ui-select-option__item -->\n    <mat-option\n      *ngFor=\"let option of filteredOptions | async; let i = index\"\n      [value]=\"option.value\"\n      class=\"shared-ui-select-option__item\"\n    >\n      <ng-container *ngIf=\"option.icon\"\n        ><i\n          [class]=\"\n            'shared-ui-select-option__item-icon ' +\n            ' ico--' +\n            options[i].icon +\n            ' ico--24'\n          \"\n        ></i\n      ></ng-container>\n      <ng-container *ngIf=\"option.label\"\n        ><span class=\"shared-ui-select-option__item-text\">{{\n          t(option.label)\n        }}</span></ng-container\n      >\n      <ng-container *ngIf=\"option.translation$ | async as translation\">{{\n        translation\n      }}</ng-container>\n    </mat-option>\n  </mat-select>\n\n  <div\n    matSuffix\n    class=\"ico--16\"\n    [ngClass]=\"isPanelOpen ? 'ico--accordion-up' : 'ico--accordion-down'\"\n  ></div>\n  <mat-error>{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n  <mat-hint *ngIf=\"hintLabel\">{{ t(hintLabel) }}</mat-hint>\n</mat-form-field>\n", styles: [".shared-ui-select{display:flex!important;align-items:center}.shared-ui-select .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix{padding-bottom:0}.shared-ui-select div.mat-mdc-select-value{overflow:unset}.shared-ui-select__item{display:flex;align-items:center;max-height:18px}.shared-ui-select__item-icon{font-size:24px;line-height:1}.shared-ui-select__item-text{padding-left:10px!important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height:18px}.shared-ui-select-option__item span.mdc-list-item__primary-text{display:flex;align-items:center}.shared-ui-select-option__item-text{padding-left:10px!important}.shared-ui-select-option__item-icon,.shared-ui-select-option__item-text{color:#707070}.shared-ui-select__search{border-bottom:1px solid #707070;background-color:#fff}.shared-ui-select__search-icon+span{z-index:-1}.shared-ui-select__search-text div.mat-select-search-no-entries-found{display:none}.shared-ui-select__search-text input.mat-select-search-input{padding-left:48px}.shared-ui-select__search button.mat-select-search-clear{display:none;cursor:pointer;pointer-events:none}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "ngmodule", type: FormFieldOutlinedModule }, { kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2.MatLabel, selector: "mat-label" }, { kind: "directive", type: i2.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i2.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "directive", type: i2.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i4.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: MatButtonModule }, { kind: "ngmodule", type: MatSelectModule }, { kind: "component", type: i5$2.MatSelect, selector: "mat-select", inputs: ["aria-describedby", "panelClass", "disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator", "placeholder", "required", "multiple", "disableOptionCentering", "compareWith", "value", "aria-label", "aria-labelledby", "errorStateMatcher", "typeaheadDebounceInterval", "sortComparator", "id", "panelWidth"], outputs: ["openedChange", "opened", "closed", "selectionChange", "valueChange"], exportAs: ["matSelect"] }, { kind: "directive", type: i5$2.MatSelectTrigger, selector: "mat-select-trigger" }, { kind: "component", type: i7.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "ngmodule", type: NgxMatSelectSearchModule }, { kind: "component", type: i7$1.MatSelectSearchComponent, selector: "ngx-mat-select-search", inputs: ["placeholderLabel", "type", "closeIcon", "closeSvgIcon", "noEntriesFoundLabel", "clearSearchInput", "searching", "disableInitialFocus", "enableClearOnEscapePressed", "preventHomeEndKeyPropagation", "disableScrollToActiveOnOptionsChanged", "ariaLabel", "showToggleAllCheckbox", "toggleAllCheckboxChecked", "toggleAllCheckboxIndeterminate", "toggleAllCheckboxTooltipMessage", "toggleAllCheckboxTooltipPosition", "hideClearSearchButton", "alwaysRestoreSelectedOptionsMulti"], outputs: ["toggleAll"] }, { kind: "directive", type: i7$1.MatSelectSearchClearDirective, selector: "[ngxMatSelectSearchClear]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
UiSelectComponent = __decorate([
    UntilDestroy(),
    __metadata("design:paramtypes", [ChangeDetectorRef])
], UiSelectComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: UiSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-select', standalone: true, imports: [
                        CommonModule,
                        FormFieldOutlinedModule,
                        ReactiveFormsModule,
                        TranslocoModule,
                        MatButtonModule,
                        MatSelectModule,
                        NgxMatSelectSearchModule,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<mat-form-field\n  *transloco=\"let t\"\n  [ngClass]=\"{ slim: slim }\"\n  [floatLabel]=\"floatLabel\"\n>\n  <mat-label #matLabel>{{ t(label) }}</mat-label>\n  <mat-select\n    [formControl]=\"control\"\n    [(value)]=\"value\"\n    (openedChange)=\"handleOnOpenedChange($event)\"\n    (selectionChange)=\"handleOnSelectChange($event)\"\n    [placeholder]=\"selectPlaceholder\"\n    class=\"shared-ui-select\"\n  >\n    <mat-select-trigger *ngIf=\"currentSelected\" class=\"shared-ui-select__item\">\n      <i\n        [class]=\"\n          'shared-ui-select__item-icon ' +\n          ' ico--' +\n          currentSelected.icon +\n          ' ico--24'\n        \"\n      ></i>\n      <span class=\"shared-ui-select__item-text\">{{\n        t(currentSelected.label || '')\n      }}</span>\n    </mat-select-trigger>\n\n    <!--   shared-ui-select__search -->\n    <mat-option class=\"shared-ui-select__search\" *ngIf=\"withSearchField\">\n      <mat-icon class=\"shared-ui-select__search-icon\" ngxMatSelectSearchClear\n        ><i class=\"ico--search ico--24\"></i\n      ></mat-icon>\n      <ngx-mat-select-search\n        class=\"shared-ui-select__search-text\"\n        [placeholderLabel]=\"label\"\n        [formControl]=\"searchFilterCtrl\"\n        [preventHomeEndKeyPropagation]=\"true\"\n      >\n      </ngx-mat-select-search>\n    </mat-option>\n\n    <!-- shared-ui-select-option__item -->\n    <mat-option\n      *ngFor=\"let option of filteredOptions | async; let i = index\"\n      [value]=\"option.value\"\n      class=\"shared-ui-select-option__item\"\n    >\n      <ng-container *ngIf=\"option.icon\"\n        ><i\n          [class]=\"\n            'shared-ui-select-option__item-icon ' +\n            ' ico--' +\n            options[i].icon +\n            ' ico--24'\n          \"\n        ></i\n      ></ng-container>\n      <ng-container *ngIf=\"option.label\"\n        ><span class=\"shared-ui-select-option__item-text\">{{\n          t(option.label)\n        }}</span></ng-container\n      >\n      <ng-container *ngIf=\"option.translation$ | async as translation\">{{\n        translation\n      }}</ng-container>\n    </mat-option>\n  </mat-select>\n\n  <div\n    matSuffix\n    class=\"ico--16\"\n    [ngClass]=\"isPanelOpen ? 'ico--accordion-up' : 'ico--accordion-down'\"\n  ></div>\n  <mat-error>{{ t(nextErrorLabel(), nextError()) }}</mat-error>\n  <mat-hint *ngIf=\"hintLabel\">{{ t(hintLabel) }}</mat-hint>\n</mat-form-field>\n", styles: [".shared-ui-select{display:flex!important;align-items:center}.shared-ui-select .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix{padding-bottom:0}.shared-ui-select div.mat-mdc-select-value{overflow:unset}.shared-ui-select__item{display:flex;align-items:center;max-height:18px}.shared-ui-select__item-icon{font-size:24px;line-height:1}.shared-ui-select__item-text{padding-left:10px!important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height:18px}.shared-ui-select-option__item span.mdc-list-item__primary-text{display:flex;align-items:center}.shared-ui-select-option__item-text{padding-left:10px!important}.shared-ui-select-option__item-icon,.shared-ui-select-option__item-text{color:#707070}.shared-ui-select__search{border-bottom:1px solid #707070;background-color:#fff}.shared-ui-select__search-icon+span{z-index:-1}.shared-ui-select__search-text div.mat-select-search-no-entries-found{display:none}.shared-ui-select__search-text input.mat-select-search-input{padding-left:48px}.shared-ui-select__search button.mat-select-search-clear{display:none;cursor:pointer;pointer-events:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { options: [{
                type: Input
            }], withSearchField: [{
                type: Input
            }], floatLabel: [{
                type: Input
            }], noOptionsPlaceholder: [{
                type: Input
            }], matLabel: [{
                type: ViewChild,
                args: ['matLabel']
            }], matSelect: [{
                type: ViewChild,
                args: [MatSelect]
            }] } });

class TitleContentComponent {
    constructor() {
        this.title = '';
        this.size = TitleSize.M;
        this.bold = false;
        this.color = 'black';
        this.truncate = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TitleContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: TitleContentComponent, isStandalone: true, selector: "shared-maps-ui-title-content", inputs: { title: "title", size: "size", bold: "bold", color: "color", type: "type", truncate: "truncate" }, ngImport: i0, template: "<div class=\"title-content-container\">\n  <shared-maps-ui-title\n    [size]=\"size\"\n    [bold]=\"bold\"\n    [color]=\"color\"\n    [title]=\"title\"\n    [type]=\"type\"\n    [truncate]=\"truncate\"\n  ></shared-maps-ui-title>\n  <ng-content></ng-content>\n</div>\n", styles: [".title-content-container{display:flex;flex-direction:column;gap:4px}.title-content-container shared-maps-ui-title{height:28px}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: TitleComponent, selector: "shared-maps-ui-title", inputs: ["bold", "color", "title", "type", "size", "truncate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TitleContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-title-content', standalone: true, imports: [CommonModule, TitleComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"title-content-container\">\n  <shared-maps-ui-title\n    [size]=\"size\"\n    [bold]=\"bold\"\n    [color]=\"color\"\n    [title]=\"title\"\n    [type]=\"type\"\n    [truncate]=\"truncate\"\n  ></shared-maps-ui-title>\n  <ng-content></ng-content>\n</div>\n", styles: [".title-content-container{display:flex;flex-direction:column;gap:4px}.title-content-container shared-maps-ui-title{height:28px}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], size: [{
                type: Input
            }], bold: [{
                type: Input
            }], color: [{
                type: Input
            }], type: [{
                type: Input,
                args: [{ required: true }]
            }], truncate: [{
                type: Input
            }] } });

const GoogleMapsGestureHandling = {
    COOPERATIVE: 'cooperative',
    GREEDY: 'greedy',
    NONE: 'none',
    AUTO: 'auto',
};

class GoogleMapsService {
    constructor(httpClient, environment) {
        this.httpClient = httpClient;
        this.environment = environment;
        this.alreadyLoaded = false;
        this.googleapisUrl = 'https://maps.googleapis.com/maps/api/js';
        this.googleapisUrlSuffix = this.environment.googleApiKey;
        this._googleMapsApiLoaded$ = this.httpClient
            .jsonp(this.googleapisUrl + this.googleapisUrlSuffix, 'callback')
            .pipe(map(() => true), tap(() => (this.alreadyLoaded = true)), catchError(() => of(false)));
    }
    get googleMapsApiLoaded$() {
        return this.alreadyLoaded ? of(true) : this._googleMapsApiLoaded$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsService, deps: [{ token: i1$1.HttpClient }, { token: 'environment' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['environment']
                }] }] });

let GoogleMapsComponent = class GoogleMapsComponent extends GoogleMap {
    set lastUsedBounds(value) {
        if (value) {
            this._lastUsedBounds = value;
        }
    }
    get clickedCoordinates() {
        return this._clickedCoordinates;
    }
    set clickedCoordinates(value) {
        this._clickedCoordinates = value;
        this.handleClickedCoordinates(this.clickedCoordinates);
    }
    set resetViewPort(resetViewPort) {
        if (resetViewPort) {
            if (this.initialViewPort?.bounds) {
                this.fitBounds(this.initialViewPort.bounds);
            }
            else {
                this.setOptions({
                    center: this.initialViewPort?.center,
                    zoom: this.initialViewPort?.zoom,
                });
            }
        }
    }
    constructor() {
        super();
        this._clickedCoordinates = null;
        this._lastUsedBounds = null;
        this.initialZoom = 7;
        this.showZoomControl = true;
        this.gestureHandling = 'auto';
        this.markersOptions = null;
        this.polylineOptions = null;
        this.hoveredCoordinates = null;
        this.height = '400px';
        this.centerOnMarkerClick = false;
        this.markerClicked = new EventEmitter();
        this.markerHover = new EventEmitter();
        this.markerHovered = new EventEmitter();
        this.mapClicked = new EventEmitter();
        this.mapDragend = new EventEmitter();
        this.mapViewPortChanged = new EventEmitter();
        this.boundsChanged = new EventEmitter();
        this.hostHeight = this.height;
        this.googleMapsService = inject(GoogleMapsService);
        this.mapLoaded$ = new Subject();
        combineLatest([this.mapLoaded$])
            .pipe(untilDestroyed(this))
            .subscribe(() => {
            this.polylineOptions &&
                this.handlePolylinesOptions(this.polylineOptions);
            this.markersOptions && this.handleMarkerOptions(this.markersOptions);
            this._lastUsedBounds && this.fitBounds(this._lastUsedBounds);
            this.clickedCoordinates && this.handleClickedCoordinates(this.clickedCoordinates);
        });
    }
    ngOnChanges(changes) {
        if (changes['hoveredCoordinates']) {
            this.handleHoveredCoordinates(this.hoveredCoordinates);
        }
    }
    ngOnInit() {
        this.hostHeight = this.height;
        this.setOptions({
            center: this.initialViewPort?.center,
            minZoom: this.initialZoom,
            zoomControl: this.showZoomControl,
            zoom: this.initialZoom,
            gestureHandling: this.gestureHandling,
        });
    }
    onBoundsChanged() {
        this.map?.getBounds();
        this.boundsChanged.emit(this.map?.getBounds());
    }
    onMapInitialized(map) {
        super.onMapInitialized(map);
        this.mapLoaded$.next();
    }
    addClusterClickEventListeners() {
        this.mapClicked.emit();
    }
    addMapClickEventListeners() {
        this.mapClicked.emit();
    }
    addMapDragEndEventListeners() {
        this.mapDragend.emit();
    }
    addMapIdleEventListeners() {
        this.updateMap();
    }
    updateMap() {
        const bounds = this.map?.getBounds();
        const center = this.map?.getCenter()?.toJSON();
        const zoom = this.map?.getZoom() ?? this.initialZoom;
        this.mapViewPortChanged.emit({ center, bounds, zoom });
    }
    addMarkerMouseOverEventListener(marker) {
        this.markerHover.emit(marker);
    }
    addMarkerMouseOutEventListener() {
        this.markerHovered.emit();
    }
    addMarkerClickEventListeners(marker) {
        marker.isClicked = !marker.isClicked;
        marker.setIcon(marker.isClicked ? marker.activeIcon : marker.defaultIcon);
        this.markerClicked.emit(marker);
        if (this.centerOnMarkerClick) {
            this.setOptions({ center: marker.getPosition(), zoom: this.map?.getZoom() });
        }
    }
    handleHoveredCoordinates(coordinates) {
        this.markers
            .filter((m) => !m.isClicked)
            .forEach((marker) => {
            if (marker.getPosition()?.lat() === coordinates?.lat &&
                marker.getPosition()?.lng() === coordinates?.lng) {
                marker.setIcon(marker.activeIcon);
            }
            else {
                marker.setIcon(marker.defaultIcon);
            }
        });
    }
    handleClickedCoordinates(coordinates) {
        this.markers.forEach((marker) => {
            if (marker.getPosition()?.lat() === coordinates?.lat &&
                marker.getPosition()?.lng() === coordinates?.lng) {
                marker.isClicked = true;
                marker.setIcon(marker.activeIcon);
            }
            else {
                marker.isClicked = false;
                marker.setIcon(marker.defaultIcon);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: GoogleMapsComponent, isStandalone: true, selector: "shared-maps-ui-google-maps", inputs: { initialViewPort: "initialViewPort", initialZoom: "initialZoom", showZoomControl: "showZoomControl", gestureHandling: "gestureHandling", lastUsedBounds: "lastUsedBounds", markersOptions: "markersOptions", polylineOptions: "polylineOptions", hoveredCoordinates: "hoveredCoordinates", clickedCoordinates: "clickedCoordinates", height: "height", resetViewPort: "resetViewPort", centerOnMarkerClick: "centerOnMarkerClick" }, outputs: { markerClicked: "markerClicked", markerHover: "markerHover", markerHovered: "markerHovered", mapClicked: "mapClicked", mapDragend: "mapDragend", mapViewPortChanged: "mapViewPortChanged", boundsChanged: "boundsChanged" }, host: { properties: { "style.height": "this.hostHeight" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"googleMapsService.googleMapsApiLoaded$ | async\">\n  <google-map\n    width=\"100%\"\n    height=\"100%\"\n    [options]=\"options\"\n    (mapInitialized)=\"onMapInitialized($event)\"\n    (boundsChanged)=\"onBoundsChanged()\"\n  >\n  </google-map>\n</ng-container>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "ngmodule", type: GoogleMapsModule }, { kind: "component", type: i2$1.GoogleMap, selector: "google-map", inputs: ["height", "width", "mapTypeId", "center", "zoom", "options"], outputs: ["mapInitialized", "authFailure", "boundsChanged", "centerChanged", "mapClick", "mapDblclick", "mapDrag", "mapDragend", "mapDragstart", "headingChanged", "idle", "maptypeidChanged", "mapMousemove", "mapMouseout", "mapMouseover", "projectionChanged", "mapRightclick", "tilesloaded", "tiltChanged", "zoomChanged"], exportAs: ["googleMap"] }] }); }
};
GoogleMapsComponent = __decorate([
    UntilDestroy(),
    __metadata("design:paramtypes", [])
], GoogleMapsComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-google-maps', standalone: true, imports: [CommonModule, GoogleMapsModule], template: "<ng-container *ngIf=\"googleMapsService.googleMapsApiLoaded$ | async\">\n  <google-map\n    width=\"100%\"\n    height=\"100%\"\n    [options]=\"options\"\n    (mapInitialized)=\"onMapInitialized($event)\"\n    (boundsChanged)=\"onBoundsChanged()\"\n  >\n  </google-map>\n</ng-container>\n" }]
        }], ctorParameters: () => [], propDecorators: { initialViewPort: [{
                type: Input
            }], initialZoom: [{
                type: Input,
                args: [{ required: false }]
            }], showZoomControl: [{
                type: Input,
                args: [{ required: false }]
            }], gestureHandling: [{
                type: Input,
                args: [{ required: false }]
            }], lastUsedBounds: [{
                type: Input
            }], markersOptions: [{
                type: Input
            }], polylineOptions: [{
                type: Input
            }], hoveredCoordinates: [{
                type: Input
            }], clickedCoordinates: [{
                type: Input
            }], height: [{
                type: Input
            }], resetViewPort: [{
                type: Input
            }], centerOnMarkerClick: [{
                type: Input
            }], markerClicked: [{
                type: Output
            }], markerHover: [{
                type: Output
            }], markerHovered: [{
                type: Output
            }], mapClicked: [{
                type: Output
            }], mapDragend: [{
                type: Output
            }], mapViewPortChanged: [{
                type: Output
            }], boundsChanged: [{
                type: Output
            }], hostHeight: [{
                type: HostBinding,
                args: ['style.height']
            }] } });

class WarningLabelComponent {
    constructor() {
        this.text = '';
        this.color = 'signal-red';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: WarningLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: WarningLabelComponent, isStandalone: true, selector: "shared-maps-ui-warning-label", inputs: { text: "text" }, ngImport: i0, template: `
    <div class="warning-label">
      <shared-maps-ui-label [color]="color"
        ><i class="ico--warning ico--16"></i
      ></shared-maps-ui-label>
      <shared-maps-ui-label [size]="'12px'" [color]="color">{{
        text
      }}</shared-maps-ui-label>
    </div>
  `, isInline: true, styles: [".warning-label{color:var(--signal-signal-rot, #ff4d37);display:flex;align-items:center;gap:8px;height:20px}.warning-label .icon-wrapper{height:20px}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: LabelComponent, selector: "shared-maps-ui-label", inputs: ["bold", "normal", "small", "color", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: WarningLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-warning-label', standalone: true, imports: [CommonModule, LabelComponent], template: `
    <div class="warning-label">
      <shared-maps-ui-label [color]="color"
        ><i class="ico--warning ico--16"></i
      ></shared-maps-ui-label>
      <shared-maps-ui-label [size]="'12px'" [color]="color">{{
        text
      }}</shared-maps-ui-label>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".warning-label{color:var(--signal-signal-rot, #ff4d37);display:flex;align-items:center;gap:8px;height:20px}.warning-label .icon-wrapper{height:20px}\n"] }]
        }], propDecorators: { text: [{
                type: Input
            }] } });

var Tab;
(function (Tab) {
    Tab["MAP"] = "map";
    Tab["LIST"] = "list";
})(Tab || (Tab = {}));

class MapBarMobileComponent {
    constructor() {
        this.Tab = Tab;
        this.TitleSize = TitleSize;
        this.text = '';
        this.selectedTab = Tab.MAP;
        this.tabSelected = new EventEmitter();
    }
    selectTab(tab) {
        this.tabSelected.emit(tab);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapBarMobileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: MapBarMobileComponent, isStandalone: true, selector: "shared-maps-ui-map-bar-mobile", inputs: { text: "text", selectedTab: "selectedTab" }, outputs: { tabSelected: "tabSelected" }, ngImport: i0, template: "<div class=\"flex border-t border-gray-300 h-14\" [ngClass]=\"{\n  'helsana-shadow-bottom': selectedTab === Tab.LIST\n}\" *transloco=\"let t\">\n  <shared-maps-ui-label class=\"flex flex-grow self-stretch border-gray-300 p-5\" [bold]=\"true\" [size]=\"TitleSize.XS\">\n    {{ text }}\n  </shared-maps-ui-label>\n  <div\n    class=\"flex flex-grow-0 cursor-pointer self-stretch border-x border-gray-300 p-4\"\n    [ngClass]=\"{\n      'border-b-4 border-b-black': selectedTab === Tab.MAP,\n      'text-gray-400': selectedTab !== Tab.MAP\n    }\"\n    (click)=\"selectTab(Tab.MAP)\"\n  >\n    {{ t('MapBarMobileComponent.karte') }}\n  </div>\n  <div\n    class=\"flex flex-grow-0 cursor-pointer self-stretch p-4\"\n    [ngClass]=\"{\n      'border-b-4 border-b-black': selectedTab === Tab.LIST,\n      'text-gray-400': selectedTab !== Tab.LIST\n    }\"\n    (click)=\"selectTab(Tab.LIST)\"\n  >\n    {{ t('MapBarMobileComponent.liste') }}\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i4.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "component", type: LabelComponent, selector: "shared-maps-ui-label", inputs: ["bold", "normal", "small", "color", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapBarMobileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-map-bar-mobile', standalone: true, imports: [CommonModule, TranslocoModule, LabelComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flex border-t border-gray-300 h-14\" [ngClass]=\"{\n  'helsana-shadow-bottom': selectedTab === Tab.LIST\n}\" *transloco=\"let t\">\n  <shared-maps-ui-label class=\"flex flex-grow self-stretch border-gray-300 p-5\" [bold]=\"true\" [size]=\"TitleSize.XS\">\n    {{ text }}\n  </shared-maps-ui-label>\n  <div\n    class=\"flex flex-grow-0 cursor-pointer self-stretch border-x border-gray-300 p-4\"\n    [ngClass]=\"{\n      'border-b-4 border-b-black': selectedTab === Tab.MAP,\n      'text-gray-400': selectedTab !== Tab.MAP\n    }\"\n    (click)=\"selectTab(Tab.MAP)\"\n  >\n    {{ t('MapBarMobileComponent.karte') }}\n  </div>\n  <div\n    class=\"flex flex-grow-0 cursor-pointer self-stretch p-4\"\n    [ngClass]=\"{\n      'border-b-4 border-b-black': selectedTab === Tab.LIST,\n      'text-gray-400': selectedTab !== Tab.LIST\n    }\"\n    (click)=\"selectTab(Tab.LIST)\"\n  >\n    {{ t('MapBarMobileComponent.liste') }}\n  </div>\n</div>\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], selectedTab: [{
                type: Input
            }], tabSelected: [{
                type: Output
            }] } });

class LinkWithIconComponent {
    constructor() {
        this.text = '';
        this.href = '';
        this.target = '_self';
        this.color = 'helsana';
        this.bold = false;
        this.size = TitleSize.M;
        this.iconOrientation = 'left';
        this.preventEvent = false;
        this.space = 1;
        this.centering = false;
        this.TitleSize = TitleSize;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LinkWithIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: LinkWithIconComponent, isStandalone: true, selector: "shared-maps-ui-link-with-icon", inputs: { text: "text", href: "href", target: "target", color: "color", icon: "icon", bold: "bold", size: "size", iconOrientation: "iconOrientation", preventEvent: "preventEvent", space: "space", centering: "centering" }, ngImport: i0, template: "<shared-maps-ui-link-wrapper\n  [text]=\"text\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [preventEvent]=\"preventEvent\"\n  class=\"flex\"\n>\n  <shared-maps-ui-label [size]=\"size\" [bold]=\"bold\" [color]=\"color\">\n    @if(iconOrientation === 'left' && icon) {\n      <i class=\"ico--{{ icon }} ico--16 mr-{{ space }}\"></i>\n      {{ text }}\n    }\n\n    @if(iconOrientation === 'right' && icon) {\n      <span class=\"flex items-center\">\n        {{ text }}\n        <i class=\"ico--{{ icon }} ico--16 ml-{{ space }}\"></i>\n      </span>\n    }\n  </shared-maps-ui-label>\n</shared-maps-ui-link-wrapper>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: LinkWrapperComponent, selector: "shared-maps-ui-link-wrapper", inputs: ["text", "href", "target", "color", "preventEvent", "isDownload"] }, { kind: "component", type: LabelComponent, selector: "shared-maps-ui-label", inputs: ["bold", "normal", "small", "color", "size"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LinkWithIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-link-with-icon', standalone: true, imports: [CommonModule, LinkWrapperComponent, LabelComponent], template: "<shared-maps-ui-link-wrapper\n  [text]=\"text\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [preventEvent]=\"preventEvent\"\n  class=\"flex\"\n>\n  <shared-maps-ui-label [size]=\"size\" [bold]=\"bold\" [color]=\"color\">\n    @if(iconOrientation === 'left' && icon) {\n      <i class=\"ico--{{ icon }} ico--16 mr-{{ space }}\"></i>\n      {{ text }}\n    }\n\n    @if(iconOrientation === 'right' && icon) {\n      <span class=\"flex items-center\">\n        {{ text }}\n        <i class=\"ico--{{ icon }} ico--16 ml-{{ space }}\"></i>\n      </span>\n    }\n  </shared-maps-ui-label>\n</shared-maps-ui-link-wrapper>\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], href: [{
                type: Input
            }], target: [{
                type: Input
            }], color: [{
                type: Input
            }], icon: [{
                type: Input
            }], bold: [{
                type: Input
            }], size: [{
                type: Input
            }], iconOrientation: [{
                type: Input
            }], preventEvent: [{
                type: Input
            }], space: [{
                type: Input
            }], centering: [{
                type: Input
            }] } });

class MapBarDesktopComponent {
    constructor() {
        this.text = '';
        this.isBackLink = false;
        this.backLinkClicked = new EventEmitter();
        this.color = 'helsana';
        this.icon = 'arrow-left';
        this.TitleSize = TitleSize;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapBarDesktopComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: MapBarDesktopComponent, isStandalone: true, selector: "shared-maps-ui-map-bar-desktop", inputs: { text: "text", isBackLink: "isBackLink" }, outputs: { backLinkClicked: "backLinkClicked" }, ngImport: i0, template: "<div class=\"flex border-t border-gray-300 h-14\">\n  <div\n    class=\"helsana-shadow-bottom border-r border-gray-300 p-5\"\n    [style.min-width]=\"'372px'\"\n  >\n    @if (isBackLink) {\n      <shared-maps-ui-link-with-icon [bold]=\"true\" [preventEvent]=\"true\" [size]=\"TitleSize.S\" [text]=\"text\" [icon]=\"icon\" [color]=\"color\" (click)=\"backLinkClicked.emit()\" />\n    }\n    @else{\n      <shared-maps-ui-label [bold]=\"true\" [size]=\"TitleSize.XS\">\n        {{ text }}\n      </shared-maps-ui-label>\n    }\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: LabelComponent, selector: "shared-maps-ui-label", inputs: ["bold", "normal", "small", "color", "size"] }, { kind: "component", type: LinkWithIconComponent, selector: "shared-maps-ui-link-with-icon", inputs: ["text", "href", "target", "color", "icon", "bold", "size", "iconOrientation", "preventEvent", "space", "centering"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapBarDesktopComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-map-bar-desktop', standalone: true, imports: [CommonModule, LabelComponent, LinkWithIconComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flex border-t border-gray-300 h-14\">\n  <div\n    class=\"helsana-shadow-bottom border-r border-gray-300 p-5\"\n    [style.min-width]=\"'372px'\"\n  >\n    @if (isBackLink) {\n      <shared-maps-ui-link-with-icon [bold]=\"true\" [preventEvent]=\"true\" [size]=\"TitleSize.S\" [text]=\"text\" [icon]=\"icon\" [color]=\"color\" (click)=\"backLinkClicked.emit()\" />\n    }\n    @else{\n      <shared-maps-ui-label [bold]=\"true\" [size]=\"TitleSize.XS\">\n        {{ text }}\n      </shared-maps-ui-label>\n    }\n  </div>\n</div>\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], isBackLink: [{
                type: Input
            }], backLinkClicked: [{
                type: Output
            }] } });

class MapBarComponent {
    constructor() {
        this.text = '';
        this.isBackLink = false;
        this.isDesktopView = true;
        this.selectedTab = Tab.MAP;
        this.backLinkClicked = new EventEmitter();
        this.tabSelected = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: MapBarComponent, isStandalone: true, selector: "shared-maps-ui-map-bar", inputs: { text: "text", isBackLink: "isBackLink", isDesktopView: "isDesktopView", selectedTab: "selectedTab" }, outputs: { backLinkClicked: "backLinkClicked", tabSelected: "tabSelected" }, ngImport: i0, template: "@if(isDesktopView){\n  <shared-maps-ui-map-bar-desktop [text]=\"text\" [isBackLink]=\"isBackLink\" (backLinkClicked)=\"backLinkClicked.emit()\"></shared-maps-ui-map-bar-desktop>\n}\n@else {\n  <shared-maps-ui-map-bar-mobile [text]=\"text\" [selectedTab]=\"selectedTab\" (tabSelected)=\"tabSelected.emit($event)\"></shared-maps-ui-map-bar-mobile>\n}\n\n\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: MapBarMobileComponent, selector: "shared-maps-ui-map-bar-mobile", inputs: ["text", "selectedTab"], outputs: ["tabSelected"] }, { kind: "component", type: MapBarDesktopComponent, selector: "shared-maps-ui-map-bar-desktop", inputs: ["text", "isBackLink"], outputs: ["backLinkClicked"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-map-bar', standalone: true, imports: [CommonModule, MapBarMobileComponent, MapBarDesktopComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "@if(isDesktopView){\n  <shared-maps-ui-map-bar-desktop [text]=\"text\" [isBackLink]=\"isBackLink\" (backLinkClicked)=\"backLinkClicked.emit()\"></shared-maps-ui-map-bar-desktop>\n}\n@else {\n  <shared-maps-ui-map-bar-mobile [text]=\"text\" [selectedTab]=\"selectedTab\" (tabSelected)=\"tabSelected.emit($event)\"></shared-maps-ui-map-bar-mobile>\n}\n\n\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], isBackLink: [{
                type: Input
            }], isDesktopView: [{
                type: Input
            }], selectedTab: [{
                type: Input
            }], backLinkClicked: [{
                type: Output
            }], tabSelected: [{
                type: Output
            }] } });

class ButtonComponent {
    constructor() {
        this.type = '';
        this.backgroundColor = '';
        this.isDisabled = false;
        this.ariaLabel = '';
        this.clickEvent = new EventEmitter();
    }
    handleClickEvent() {
        this.clickEvent.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: ButtonComponent, isStandalone: true, selector: "shared-maps-ui-button", inputs: { title: "title", type: "type", backgroundColor: "backgroundColor", isDisabled: "isDisabled", ariaLabel: "ariaLabel" }, outputs: { clickEvent: "clickEvent" }, ngImport: i0, template: "<button\n  type=\"button\"\n  title=\"{{ title }}\"\n  class=\"btn flex justify-center max-lg:w-full\"\n  [ngClass]=\"[type, backgroundColor]\"\n  [disabled]=\"isDisabled\"\n  [attr.aria-label]=\"ariaLabel\"\n  role=\"button\"\n  (click)=\"handleClickEvent()\"\n>\n  <ng-content></ng-content>\n  {{ title }}\n</button>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-button', standalone: true, imports: [CommonModule], template: "<button\n  type=\"button\"\n  title=\"{{ title }}\"\n  class=\"btn flex justify-center max-lg:w-full\"\n  [ngClass]=\"[type, backgroundColor]\"\n  [disabled]=\"isDisabled\"\n  [attr.aria-label]=\"ariaLabel\"\n  role=\"button\"\n  (click)=\"handleClickEvent()\"\n>\n  <ng-content></ng-content>\n  {{ title }}\n</button>\n" }]
        }], propDecorators: { title: [{
                type: Input,
                args: [{ required: true }]
            }], type: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], clickEvent: [{
                type: Output
            }] } });

class ListItemComponent {
    constructor() {
        this.isActive = false;
        this.withChevron = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: ListItemComponent, isStandalone: true, selector: "shared-maps-ui-list-item", inputs: { isActive: "isActive", withChevron: "withChevron" }, ngImport: i0, template: "<div\n  class=\"cursor-pointer border-b border-gray-200 p-4\"\n  [ngClass]=\"{\n    'bg-gray-100': isActive,\n  }\"\n>\n  <div class=\"flex justify-between\">\n    <ng-content select=\"[item-body]\"></ng-content>\n    @if(withChevron) {\n    <div class=\"flex\">\n      <div class=\"self-center\">\n        <div class=\"ico--chevron-right ico--24\"></div>\n      </div>\n    </div>\n    }\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-list-item', standalone: true, imports: [CommonModule], template: "<div\n  class=\"cursor-pointer border-b border-gray-200 p-4\"\n  [ngClass]=\"{\n    'bg-gray-100': isActive,\n  }\"\n>\n  <div class=\"flex justify-between\">\n    <ng-content select=\"[item-body]\"></ng-content>\n    @if(withChevron) {\n    <div class=\"flex\">\n      <div class=\"self-center\">\n        <div class=\"ico--chevron-right ico--24\"></div>\n      </div>\n    </div>\n    }\n  </div>\n</div>\n" }]
        }], propDecorators: { isActive: [{
                type: Input
            }], withChevron: [{
                type: Input
            }] } });

class ListComponent {
    constructor() {
        this.direction = 'column';
        this.overlayScroll = false;
        this.centering = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: ListComponent, isStandalone: true, selector: "shared-maps-ui-list", inputs: { direction: "direction", overlayScroll: "overlayScroll", centering: "centering" }, ngImport: i0, template: "<div [ngClass]=\"{ 'overflow-scroll': overlayScroll }\" >\n  <div class=\"flex\" [ngClass]=\"{ 'flex-col': direction === 'column', 'items-center': centering }\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-list', standalone: true, imports: [CommonModule], template: "<div [ngClass]=\"{ 'overflow-scroll': overlayScroll }\" >\n  <div class=\"flex\" [ngClass]=\"{ 'flex-col': direction === 'column', 'items-center': centering }\">\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], propDecorators: { direction: [{
                type: Input
            }], overlayScroll: [{
                type: Input
            }], centering: [{
                type: Input
            }] } });

class PreviewPanelComponent {
    constructor() {
        this.title = '';
        this.linkText = '';
        this.linkColor = 'helsana';
        this.href = null;
        this.target = '_self';
        this.bold = false;
        this.iconOrientation = 'left';
        this.preventEvent = false;
        this.isNil = isNil;
        this.TitleSize = TitleSize;
        this.TitleType = TitleType;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: PreviewPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: PreviewPanelComponent, isStandalone: true, selector: "shared-maps-ui-preview-panel", inputs: { title: "title", linkText: "linkText", linkColor: "linkColor", href: "href", target: "target", icon: "icon", bold: "bold", iconOrientation: "iconOrientation", preventEvent: "preventEvent" }, ngImport: i0, template: "<div\n  class=\"helsana-shadow-top absolute bottom-0 h-fit w-full rounded-[5px] border-t border-t-gray-200 bg-white p-4\"\n>\n  <div class=\"flex cursor-pointer justify-between\">\n    <shared-maps-ui-list class=\"w-full\">\n      <shared-maps-ui-title-content\n        [title]=\"title\"\n        [bold]=\"true\"\n        [size]=\"TitleSize.XS\"\n        [type]=\"TitleType.H4\"\n      />\n      <ng-content></ng-content>\n      @if(!isNil(href) && linkText) {\n      <shared-maps-ui-link-with-icon\n        [icon]=\"icon\"\n        [iconOrientation]=\"iconOrientation\"\n        [text]=\"linkText\"\n        [color]=\"linkColor\"\n        [bold]=\"bold\"\n        [href]=\"href\"\n        [size]=\"TitleSize.XXS\"\n        [preventEvent]=\"preventEvent\"\n        [centering]=\"true\"\n        [target]=\"target\"\n        class=\"mt-4\"\n      />\n      }\n    </shared-maps-ui-list>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: ListComponent, selector: "shared-maps-ui-list", inputs: ["direction", "overlayScroll", "centering"] }, { kind: "component", type: TitleContentComponent, selector: "shared-maps-ui-title-content", inputs: ["title", "size", "bold", "color", "type", "truncate"] }, { kind: "component", type: LinkWithIconComponent, selector: "shared-maps-ui-link-with-icon", inputs: ["text", "href", "target", "color", "icon", "bold", "size", "iconOrientation", "preventEvent", "space", "centering"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: PreviewPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-preview-panel', standalone: true, imports: [
                        CommonModule,
                        ListComponent,
                        TitleContentComponent,
                        LinkWithIconComponent,
                    ], template: "<div\n  class=\"helsana-shadow-top absolute bottom-0 h-fit w-full rounded-[5px] border-t border-t-gray-200 bg-white p-4\"\n>\n  <div class=\"flex cursor-pointer justify-between\">\n    <shared-maps-ui-list class=\"w-full\">\n      <shared-maps-ui-title-content\n        [title]=\"title\"\n        [bold]=\"true\"\n        [size]=\"TitleSize.XS\"\n        [type]=\"TitleType.H4\"\n      />\n      <ng-content></ng-content>\n      @if(!isNil(href) && linkText) {\n      <shared-maps-ui-link-with-icon\n        [icon]=\"icon\"\n        [iconOrientation]=\"iconOrientation\"\n        [text]=\"linkText\"\n        [color]=\"linkColor\"\n        [bold]=\"bold\"\n        [href]=\"href\"\n        [size]=\"TitleSize.XXS\"\n        [preventEvent]=\"preventEvent\"\n        [centering]=\"true\"\n        [target]=\"target\"\n        class=\"mt-4\"\n      />\n      }\n    </shared-maps-ui-list>\n  </div>\n</div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], linkText: [{
                type: Input
            }], linkColor: [{
                type: Input
            }], href: [{
                type: Input
            }], target: [{
                type: Input
            }], icon: [{
                type: Input
            }], bold: [{
                type: Input
            }], iconOrientation: [{
                type: Input
            }], preventEvent: [{
                type: Input
            }] } });

class TabComponent {
    constructor() {
        this.title = '';
        this.color = 'black';
        this.bold = false;
        this.isActive = false;
        this.colors = colors;
        this.titleType = TitleType.H3;
        this.titleSize = TitleSize.S;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: TabComponent, isStandalone: true, selector: "shared-maps-ui-tab", inputs: { title: "title", color: "color", bold: "bold", isActive: "isActive" }, ngImport: i0, template: "<div\n    class=\"flex flex-grow-0 justify-center cursor-pointer self-stretch p-4\"\n    [ngClass]=\"{ 'border-b-4': isActive, 'border-b-2': !isActive }\"\n    [style.borderColor]=\"isActive ? colors[this.color] : colors['gray-200']\"\n  >\n    <shared-maps-ui-title [type]=\"titleType\" [size]=\"titleSize\" [title]=\"title\" [color]=\"color\" [bold]=\"bold\"/>\n  </div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: TitleComponent, selector: "shared-maps-ui-title", inputs: ["bold", "color", "title", "type", "size", "truncate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-tab', standalone: true, imports: [CommonModule, TitleComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n    class=\"flex flex-grow-0 justify-center cursor-pointer self-stretch p-4\"\n    [ngClass]=\"{ 'border-b-4': isActive, 'border-b-2': !isActive }\"\n    [style.borderColor]=\"isActive ? colors[this.color] : colors['gray-200']\"\n  >\n    <shared-maps-ui-title [type]=\"titleType\" [size]=\"titleSize\" [title]=\"title\" [color]=\"color\" [bold]=\"bold\"/>\n  </div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], color: [{
                type: Input
            }], bold: [{
                type: Input
            }], isActive: [{
                type: Input
            }] } });

class TabBarComponent {
    constructor() {
        this.options = [];
        this.color = 'black';
        this.withBorder = false;
        this.optionsChange = new EventEmitter();
    }
    handleTabActive(idx) {
        this.options = this.options.map((option, i) => ({
            ...option,
            isActive: i === idx,
        }));
        this.optionsChange.emit(this.options);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TabBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: TabBarComponent, isStandalone: true, selector: "shared-maps-ui-tab-bar", inputs: { options: "options", color: "color", withBorder: "withBorder" }, outputs: { optionsChange: "optionsChange" }, ngImport: i0, template: "<div class=\"flex\">\n  @for (option of options; track index; let index = $index;  let first = $first; let last = $last) {\n    <div class=\"border-gray-300 grow\" [ngClass]=\"{ 'border-x': first && withBorder, 'border-r': !first && withBorder }\">\n      <shared-maps-ui-tab [color]=\"option.isActive ? color: 'black' \" [title]=\"option.title\" [isActive]=\"option.isActive\" (click)=\"handleTabActive(index)\" />\n    </div>\n  }\n</div>\n\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: TabComponent, selector: "shared-maps-ui-tab", inputs: ["title", "color", "bold", "isActive"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TabBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-tab-bar', standalone: true, imports: [CommonModule, TabComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flex\">\n  @for (option of options; track index; let index = $index;  let first = $first; let last = $last) {\n    <div class=\"border-gray-300 grow\" [ngClass]=\"{ 'border-x': first && withBorder, 'border-r': !first && withBorder }\">\n      <shared-maps-ui-tab [color]=\"option.isActive ? color: 'black' \" [title]=\"option.title\" [isActive]=\"option.isActive\" (click)=\"handleTabActive(index)\" />\n    </div>\n  }\n</div>\n\n" }]
        }], propDecorators: { options: [{
                type: Input
            }], color: [{
                type: Input
            }], withBorder: [{
                type: Input
            }], optionsChange: [{
                type: Output
            }] } });

class ChipButtonComponent {
    constructor() {
        this.text = '';
        this.iconOrientation = 'left';
        this.color = 'helsana';
        this.buttonClick = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ChipButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.3", type: ChipButtonComponent, isStandalone: true, selector: "shared-maps-ui-chip-button", inputs: { icon: "icon", text: "text", iconOrientation: "iconOrientation", color: "color" }, outputs: { buttonClick: "buttonClick" }, ngImport: i0, template: "<div\n  class=\"chip-button cursor-pointer rounded-full px-4 py-2\"\n  (click)=\"buttonClick.emit()\"\n>\n  @if(iconOrientation === 'left' && icon ){\n  <shared-maps-ui-label [color]=\"color\" class=\"mr-2\">\n    <i class=\"ico--{{ icon }} ico--16\"></i>\n  </shared-maps-ui-label>\n  }\n\n  <shared-maps-ui-label [color]=\"color\">{{ text }}</shared-maps-ui-label>\n\n  @if(iconOrientation === 'right' && icon){\n  <shared-maps-ui-label [color]=\"color\" class=\"ml-2\">\n    <i class=\"ico--{{ icon }} ico--16\"></i>\n  </shared-maps-ui-label>\n  }\n</div>\n", styles: [".chip-button{display:flex;align-items:center;width:fit-content;background-color:#fff}.chip-button span{height:24px}.chip-button span i:before{line-height:unset}\n"], dependencies: [{ kind: "component", type: LabelComponent, selector: "shared-maps-ui-label", inputs: ["bold", "normal", "small", "color", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ChipButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-chip-button', standalone: true, imports: [LabelComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"chip-button cursor-pointer rounded-full px-4 py-2\"\n  (click)=\"buttonClick.emit()\"\n>\n  @if(iconOrientation === 'left' && icon ){\n  <shared-maps-ui-label [color]=\"color\" class=\"mr-2\">\n    <i class=\"ico--{{ icon }} ico--16\"></i>\n  </shared-maps-ui-label>\n  }\n\n  <shared-maps-ui-label [color]=\"color\">{{ text }}</shared-maps-ui-label>\n\n  @if(iconOrientation === 'right' && icon){\n  <shared-maps-ui-label [color]=\"color\" class=\"ml-2\">\n    <i class=\"ico--{{ icon }} ico--16\"></i>\n  </shared-maps-ui-label>\n  }\n</div>\n", styles: [".chip-button{display:flex;align-items:center;width:fit-content;background-color:#fff}.chip-button span{height:24px}.chip-button span i:before{line-height:unset}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], text: [{
                type: Input
            }], iconOrientation: [{
                type: Input
            }], color: [{
                type: Input
            }], buttonClick: [{
                type: Output
            }] } });

function parseD3Waypoints(waypointsArray, trailLength) {
    return waypointsArray.map((waypoint, index) => {
        return {
            waypointIndex: (index * (trailLength / waypointsArray.length)) / 1000,
            lat: waypoint[0],
            lng: waypoint[1],
            elevation: waypoint[2],
        };
    });
}

class ElevationProfileComponent {
    constructor() {
        this.TitleType = TitleType;
        this.TitleSize = TitleSize;
        // Declare the chart dimensions and margins.
        this.width = 640;
        this.marginTop = 40;
        this.marginRight = 20;
        this.marginBottom = 55;
        this.marginLeft = 40;
        this.trailLength = 0;
        this.translocoService = inject(TranslocoService);
        this.waypoints = [];
        this.title = '';
        this.height = 400;
        this.xTickLabels = false;
        this.yTickLabels = false;
        this.elevationProfileContainer = null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get trail() {
        return this._trail;
    }
    set trail(value) {
        this._trail = value;
        d3.select('.graph').selectAll('*').remove();
        this.elevationProfileContainer = document.querySelector('.elevation-profile-container');
    }
    ngOnInit() {
        if (this.elevationProfileContainer) {
            this.width = this.elevationProfileContainer.clientWidth;
        }
        this.setupProfileContainer();
        this.setData();
    }
    setupProfileContainer() {
        if (!this.svg) {
            let container = document.querySelector('.elevation-profile-container');
            if (!container) {
                container = document
                    .querySelector('trails-component')
                    .shadowRoot.querySelector('.elevation-profile-container');
            }
            this.width = container.clientWidth;
            this.svg = d3
                .select(container)
                .append('svg')
                .attr('width', '100%')
                .attr('height', this.height)
                .style('background', '#f2f2f280')
                .append('g')
                .attr('class', 'graph');
        }
    }
    setData() {
        this.waypoints = parseD3Waypoints(this._trail.waypoints, this._trail.lengthMeters);
        this.trailLength = this.trail.lengthMeters;
        const minElevation = d3.min(this.waypoints, (d) => d.elevation) ?? 0;
        const maxElevation = d3.max(this.waypoints, (d) => d.elevation) ?? 0;
        const xAxis = d3
            .scaleLinear()
            .domain([0, this.trailLength / 1000])
            .range([this.marginLeft, this.width - this.marginRight]);
        const yAxis = d3
            .scaleLinear()
            .domain([minElevation - 20, maxElevation + 20])
            .range([this.height - this.marginBottom, this.marginTop]);
        if (this.xTickLabels) {
            this.svg
                .append('g')
                .attr('class', 'axis')
                .attr('transform', `translate(0,${this.height - this.marginBottom})`)
                .call(d3
                .axisBottom(xAxis)
                .tickFormat(d3.format(',.1f'))
                .ticks(this.width / 60))
                .append("text")
                .attr("x", ("98%"))
                .attr("y", 40)
                .attr("fill", "currentColor")
                .attr("text-anchor", "end")
                .text(this.translocoService.translate('ElevationProfile.xAchse'));
        }
        if (this.yTickLabels) {
            this.svg
                .append('g')
                .attr('transform', `translate(${this.marginLeft},0)`)
                .attr('class', 'axis')
                .call(d3
                .axisLeft(yAxis)
                .tickSize(this.marginRight + this.marginLeft - this.width)
                .ticks(this.height / 30))
                .append("text")
                .attr("x", -28)
                .attr("y", 25)
                .attr("fill", "currentColor")
                .attr("text-anchor", "start")
                .text(this.translocoService.translate('ElevationProfile.yAchse'));
        }
        const line = d3
            .line()
            .x((d) => xAxis(d.waypointIndex))
            .y((d) => yAxis(d.elevation))
            .curve(d3.curveNatural);
        this.svg
            .append('path')
            .attr('fill', 'none')
            .attr('stroke', getTrailsColor(this.trail.type))
            .attr('stroke-width', 4)
            .attr('d', line(this.waypoints));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ElevationProfileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: ElevationProfileComponent, isStandalone: true, selector: "shared-maps-ui-elevation-profile", inputs: { trail: "trail", title: "title", height: "height", xTickLabels: "xTickLabels", yTickLabels: "yTickLabels" }, viewQueries: [{ propertyName: "elevationProfileContainer", first: true, predicate: ["elevationContainer"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"my-4\">\n  <shared-maps-ui-title\n    [type]=\"TitleType.H4\"\n    [title]=\"title\"\n    [bold]=\"true\"\n    [size]=\"TitleSize.XS\"\n  ></shared-maps-ui-title>\n  <div #elevationContainer class=\"elevation-profile-container\"></div>\n</div>\n", styles: [".elevation-profile{background-color:#f2f2f280}.elevation-profile-container{margin-top:14px}.axis .tick line{stroke:#e0e0e0;stroke-width:1;shape-rendering:crispEdges}.axis path{stroke:none}.axis text{fill:#949494;font-family:AkkuratHelsanaTT Web,Helvetica,Arial,sans-serif;font-size:.9rem}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: TitleComponent, selector: "shared-maps-ui-title", inputs: ["bold", "color", "title", "type", "size", "truncate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ElevationProfileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-elevation-profile', standalone: true, encapsulation: ViewEncapsulation.None, imports: [CommonModule, TitleComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"my-4\">\n  <shared-maps-ui-title\n    [type]=\"TitleType.H4\"\n    [title]=\"title\"\n    [bold]=\"true\"\n    [size]=\"TitleSize.XS\"\n  ></shared-maps-ui-title>\n  <div #elevationContainer class=\"elevation-profile-container\"></div>\n</div>\n", styles: [".elevation-profile{background-color:#f2f2f280}.elevation-profile-container{margin-top:14px}.axis .tick line{stroke:#e0e0e0;stroke-width:1;shape-rendering:crispEdges}.axis path{stroke:none}.axis text{fill:#949494;font-family:AkkuratHelsanaTT Web,Helvetica,Arial,sans-serif;font-size:.9rem}\n"] }]
        }], propDecorators: { trail: [{
                type: Input
            }], title: [{
                type: Input
            }], height: [{
                type: Input
            }], xTickLabels: [{
                type: Input
            }], yTickLabels: [{
                type: Input
            }], elevationProfileContainer: [{
                type: ViewChild,
                args: ['elevationContainer', { static: true }]
            }] } });

class DownloadLinkComponent {
    constructor() {
        this.text = '';
        this.href = '';
        this.color = 'helsana';
        this.preventEvent = false;
        this.target = '_self';
        this.TitleSize = TitleSize;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DownloadLinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: DownloadLinkComponent, isStandalone: true, selector: "shared-maps-ui-download-link", inputs: { text: "text", href: "href", color: "color", preventEvent: "preventEvent", target: "target" }, ngImport: i0, template: "<shared-maps-ui-link-wrapper\n  [style.font-size]=\"TitleSize.XS\"\n  [text]=\"text\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [preventEvent]=\"false\"\n  class=\"flex\"\n  [isDownload]=\"true\"\n>\n  <shared-maps-ui-label [color]=\"color\" class=\"flex basis-auto\">\n    <i class=\"ico--doc-download ico--32\"></i>\n    {{ text }}\n  </shared-maps-ui-label>\n</shared-maps-ui-link-wrapper>\n", styles: ["shared-maps-ui-link-wrapper a shared-maps-ui-label span{align-items:center}\n"], dependencies: [{ kind: "component", type: LabelComponent, selector: "shared-maps-ui-label", inputs: ["bold", "normal", "small", "color", "size"] }, { kind: "component", type: LinkWrapperComponent, selector: "shared-maps-ui-link-wrapper", inputs: ["text", "href", "target", "color", "preventEvent", "isDownload"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DownloadLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-download-link', standalone: true, imports: [LabelComponent, LinkWrapperComponent], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<shared-maps-ui-link-wrapper\n  [style.font-size]=\"TitleSize.XS\"\n  [text]=\"text\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [preventEvent]=\"false\"\n  class=\"flex\"\n  [isDownload]=\"true\"\n>\n  <shared-maps-ui-label [color]=\"color\" class=\"flex basis-auto\">\n    <i class=\"ico--doc-download ico--32\"></i>\n    {{ text }}\n  </shared-maps-ui-label>\n</shared-maps-ui-link-wrapper>\n", styles: ["shared-maps-ui-link-wrapper a shared-maps-ui-label span{align-items:center}\n"] }]
        }], propDecorators: { text: [{
                type: Input
            }], href: [{
                type: Input
            }], color: [{
                type: Input
            }], preventEvent: [{
                type: Input
            }], target: [{
                type: Input
            }] } });

class GoogleMapsButtonComponent {
    constructor() {
        this.icon = 'link-external';
        this.backgroundColor = 'black';
        this.buttonClick = new EventEmitter();
    }
    handleClickEvent() {
        this.buttonClick.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: GoogleMapsButtonComponent, isStandalone: true, selector: "shared-maps-ui-google-maps-button", inputs: { title: "title", icon: "icon", backgroundColor: "backgroundColor" }, outputs: { buttonClick: "buttonClick" }, ngImport: i0, template: "<shared-maps-ui-button\n[title]=\"title\"\nbackgroundColor=\"{{ backgroundColor }}\"\nclass=\"md:w-full\"\n(clickEvent)=\"handleClickEvent()\"\n >\n <span class=\"ico--{{ icon }} ico--24 mr-3\"></span>\n</shared-maps-ui-button>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: ButtonComponent, selector: "shared-maps-ui-button", inputs: ["title", "type", "backgroundColor", "isDisabled", "ariaLabel"], outputs: ["clickEvent"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-maps-ui-google-maps-button', standalone: true, imports: [CommonModule, ButtonComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<shared-maps-ui-button\n[title]=\"title\"\nbackgroundColor=\"{{ backgroundColor }}\"\nclass=\"md:w-full\"\n(clickEvent)=\"handleClickEvent()\"\n >\n <span class=\"ico--{{ icon }} ico--24 mr-3\"></span>\n</shared-maps-ui-button>\n" }]
        }], propDecorators: { title: [{
                type: Input,
                args: [{ required: true }]
            }], icon: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], buttonClick: [{
                type: Output
            }] } });

class ResetLocationButtonDirective {
    set googleMapsComponent(map) {
        this.chipButton.iconOrientation = 'left';
        this.chipButton.text = this.translocoService.translate('GoogleMap.neuZentrieren');
        this.chipButton.color = 'helsana';
        this.chipButton.icon = 'direction';
        this.chipButton.buttonClick
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.onChipButtonClick(map);
        });
        map.mapViewPortChanged
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => {
            this.onMapViewPortChange(event, map);
        });
    }
    constructor(chipButton, el) {
        this.chipButton = chipButton;
        this.el = el;
        this.cdRef = inject(ChangeDetectorRef);
        this.destroyRef = inject(DestroyRef);
        this.translocoService = inject(TranslocoService);
        this.isInitialViewport = true;
        this.initialMapChange = true;
        this.buttonElement = this.el.nativeElement;
        this.viewPortUpdated = signal(false);
        this.hideButton();
    }
    onChipButtonClick(map) {
        this.hideButton();
        this.isInitialViewport = true;
        map.resetViewPort = true;
    }
    onMapViewPortChange(event, map) {
        // If the viewport was set from outside and viewPortUpdated is true a new initial viewport was set
        if (this.viewPortUpdated()) {
            this.isInitialViewport = true;
        }
        if (this.initialMapChange) {
            map.initialViewPort = event;
            this.initialMapChange = false;
        }
        else if (!this.isInitialViewport && !this.viewPortUpdated()) {
            this.showButton();
            this.cdRef.detectChanges();
        }
        if (this.isInitialViewport) {
            this.hideButton();
            this.isInitialViewport = false;
        }
        this.viewPortUpdated.set(false);
    }
    showButton() {
        this.buttonElement.classList.remove('hidden');
    }
    hideButton() {
        this.buttonElement.classList.add('hidden');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ResetLocationButtonDirective, deps: [{ token: ChipButtonComponent }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.3", type: ResetLocationButtonDirective, isStandalone: true, selector: "[helsanaMapUiResetLocationButton]", inputs: { viewPortUpdated: "viewPortUpdated", googleMapsComponent: "googleMapsComponent" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ResetLocationButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[helsanaMapUiResetLocationButton]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: ChipButtonComponent }, { type: i0.ElementRef }], propDecorators: { viewPortUpdated: [{
                type: Input
            }], googleMapsComponent: [{
                type: Input
            }] } });

const trailsLocationMock = [
    {
        id: '46',
        name: 'Scharans GR',
        postalCode: '7412',
        city: 'Scharans GR',
        coordinates: {
            lat: 47.39735060953535,
            lng: 8.597899954766035,
        },
        trails: [
            {
                id: '237',
                type: TrailType.Blue,
                name: 'Scharans blue',
                startAddress: 'Lorem ipsum dolor sit amet!',
                finishAddress: 'Lorem ipsum dolor sit amet!',
                lengthMeters: 5227,
                climbMeters: 135,
                descentMeters: 135,
                isClosed: true,
                closedReason: '',
                special: '',
                waypoints: [
                    [47.39735150896013, 8.59789997432381, 437.59999084472656],
                    [47.39734980324283, 8.59789066389203, 437.59999084472656],
                    [47.39762045489624, 8.597990612033755, 437.59999084472656],
                    [47.39762307307683, 8.597998617682606, 437.59999084472656],
                    [47.39762307307683, 8.597998617682606, 437.59999084472656],
                    [47.39762045489624, 8.597990612033755, 437.59999084472656],
                    [47.39775039115921, 8.598039806820452, 437.1999969482422],
                    [47.39766041841358, 8.598579681944102, 436.5],
                    [47.397661317605525, 8.598579701501876, 436.5],
                    [47.397661317605525, 8.598579701501876, 436.5],
                    [47.39766041841358, 8.598579681944102, 436.5],
                    [47.397549939807504, 8.599190645851195, 436.5],
                    [47.397558007156476, 8.599193471018225, 436.5],
                    [47.397558007156476, 8.599193471018225, 436.5],
                    [47.397549939807504, 8.599190645851195, 436.5],
                    [47.39747996558435, 8.599619672168046, 436.5],
                    [47.39748534816317, 8.599621114321053, 436.5],
                    [47.39748534816317, 8.599621114321053, 436.5],
                    [47.39747996558435, 8.599619672168046, 436.5],
                    [47.39743037917651, 8.599899442400783, 435.79998779296875],
                    [47.39776009134948, 8.600029833614826, 435.6999969482422],
                    [47.39776997780427, 8.600120134186, 435.59999084472656],
                    [47.39780995459296, 8.600170022342354, 435.5],
                    [47.397870315704495, 8.600160740315914, 435.5],
                    [47.397909705294296, 8.600090060848743, 435.6999969482422],
                    [47.398180447751656, 8.60018074978143, 434.59999084472656],
                    [47.39818132063374, 8.600183418486267, 434.59999084472656],
                    [47.39818132063374, 8.600183418486267, 434.59999084472656],
                    [47.398180447751656, 8.60018074978143, 434.59999084472656],
                    [47.398590025957674, 8.600330108311027, 434.59999084472656],
                    [47.398590858560055, 8.60033675050363, 434.59999084472656],
                    [47.398590858560055, 8.60033675050363, 434.59999084472656],
                    [47.398590025957674, 8.600330108311027, 434.59999084472656],
                    [47.39901039539836, 8.600479704793543, 433.8999938964844],
                    [47.39901478542015, 8.600490398705006, 433.8999938964844],
                    [47.39901478542015, 8.600490398705006, 433.8999938964844],
                    [47.39901039539836, 8.600479704793543, 433.8999938964844],
                    [47.39934990578331, 8.600619590841234, 433.3999938964844],
                    [47.3993901880458, 8.600460166111588, 433.29998779296875],
                    [47.39953972096555, 8.600349492859095, 433],
                    [47.39954413753003, 8.600357538089156, 433],
                    [47.39954413753003, 8.600357538089156, 433],
                    [47.39953972096555, 8.600349492859095, 433],
                    [47.39964047004469, 8.600170188583434, 432.79998779296875],
                    [47.399640476098284, 8.600080100819468, 432.6999969482422],
                    [47.3996494426392, 8.600082946009934, 432.6999969482422],
                    [47.3996494426392, 8.600082946009934, 432.6999969482422],
                    [47.399640476098284, 8.600080100819468, 432.6999969482422],
                    [47.39963028929196, 8.59993017371744, 433.09999084472656],
                    [47.39957053307444, 8.599789764732122, 433.1999969482422],
                    [47.399570466484874, 8.59979638736695, 433.1999969482422],
                    [47.399570466484874, 8.59979638736695, 433.1999969482422],
                    [47.39957053307444, 8.599789764732122, 433.1999969482422],
                    [47.399430316872895, 8.599599909037352, 433.29998779296875],
                    [47.39930968056433, 8.599520440679044, 433.5],
                    [47.3993150498718, 8.599523207172751, 433.5],
                    [47.3993150498718, 8.599523207172751, 433.5],
                    [47.39930968056433, 8.599520440679044, 433.5],
                    [47.39913018140942, 8.599390672054142, 434.5],
                    [47.399200352374464, 8.59921070188284, 434.79998779296875],
                    [47.399259933503345, 8.599189477972686, 434.79998779296875],
                    [47.39934969483875, 8.598939718212932, 434.6999969482422],
                    [47.39935140032321, 8.59894902864471, 434.6999969482422],
                    [47.39935140032321, 8.59894902864471, 434.6999969482422],
                    [47.39934969483875, 8.598939718212932, 434.6999969482422],
                    [47.39951033447869, 8.598349696956575, 435.59999084472656],
                    [47.399514778051525, 8.598355093039572, 435.59999084472656],
                    [47.399514778051525, 8.598355093039572, 435.59999084472656],
                    [47.39951033447869, 8.598349696956575, 435.59999084472656],
                    [47.39959999220446, 8.598020443227142, 436.29998779296875],
                    [47.39927008305676, 8.597819840535522, 436.79998779296875],
                    [47.399270955706015, 8.597822509240359, 436.79998779296875],
                    [47.399270955706015, 8.597822509240359, 436.79998779296875],
                    [47.39927008305676, 8.597819840535522, 436.79998779296875],
                    [47.398739881347865, 8.597499625291675, 437.8999938964844],
                    [47.398741653421894, 8.597502313554287, 437.8999938964844],
                    [47.398741653421894, 8.597502313554287, 437.8999938964844],
                    [47.398739881347865, 8.597499625291675, 437.8999938964844],
                    [47.398390372050926, 8.597280055750161, 438.1999969482422],
                    [47.398392977193, 8.597289386205375, 438.1999969482422],
                    [47.398392977193, 8.597289386205375, 438.1999969482422],
                    [47.398390372050926, 8.597280055750161, 438.1999969482422],
                    [47.397990291705355, 8.596990501042455, 439.3999938964844],
                    [47.3979965869803, 8.596990637946874, 439.3999938964844],
                    [47.3979965869803, 8.596990637946874, 439.3999938964844],
                    [47.397990291705355, 8.596990501042455, 439.3999938964844],
                    [47.39774014148861, 8.596819465048611, 440],
                    [47.39772974769585, 8.596779495943338, 439.8999938964844],
                    [47.39773600315675, 8.59678360633552, 439.8999938964844],
                    [47.39773600315675, 8.59678360633552, 439.8999938964844],
                    [47.39772974769585, 8.596779495943338, 439.8999938964844],
                    [47.39768027840182, 8.596599575597793, 439.79998779296875],
                    [47.39739981968887, 8.596670316532254, 440.1999969482422],
                    [47.397406075149775, 8.596674426924437, 440.1999969482422],
                    [47.397406075149775, 8.596674426924437, 440.1999969482422],
                    [47.39739981968887, 8.596670316532254, 440.1999969482422],
                    [47.39701022463851, 8.596770478412509, 440.6999969482422],
                    [47.39671968086623, 8.596680703107268, 440.8999938964844],
                    [47.3966602194123, 8.596690008882433, 440.8999938964844],
                    [47.396619932493195, 8.596760669257492, 441],
                    [47.396580156404525, 8.596959841437638, 440.8999938964844],
                    [47.3965828276705, 8.596962549258024, 440.8999938964844],
                    [47.3965828276705, 8.596962549258024, 440.8999938964844],
                    [47.396580156404525, 8.596959841437638, 440.8999938964844],
                    [47.39648998528719, 8.597609655931592, 440],
                    [47.396650498732924, 8.597659513819963, 439.29998779296875],
                    [47.39665224426426, 8.597664850763977, 439.29998779296875],
                    [47.39665224426426, 8.597664850763977, 439.29998779296875],
                    [47.396650498732924, 8.597659513819963, 439.29998779296875],
                    [47.396969713736326, 8.59776051575318, 438.29998779296875],
                    [47.39697234518826, 8.59776719706133, 438.29998779296875],
                    [47.39697234518826, 8.59776719706133, 438.29998779296875],
                    [47.396969713736326, 8.59776051575318, 438.29998779296875],
                    [47.39725025789812, 8.597860678099096, 438.29998779296875],
                    [47.39725919789635, 8.597866171505302, 438.29998779296875],
                ],
                gpxUrl: '/uploads/trails_gpx/scharans_blau_585416927e217.gpx',
                responsible: {
                    id: '7',
                    name: 'Giuseppe Torri',
                    email: 'giuseppe.torri@bluewin.ch',
                    phone: '079 575 92 42',
                },
            },
            {
                id: '39',
                type: TrailType.Green,
                name: 'Scharans green',
                startAddress: 'Carutt 58\u003Cbr /\u003E\r\n7412 Scharans',
                finishAddress: 'Carutt 58\u003Cbr /\u003E\r\n7412 Scharans',
                lengthMeters: 8324,
                climbMeters: 197,
                descentMeters: 196,
                isClosed: false,
                closedReason: '',
                special: '',
                waypoints: [
                    [47.39735060953535, 8.597899954766035, 437.59999084472656],
                    [47.39734980324283, 8.59789066389203, 437.59999084472656],
                    [47.39762045489624, 8.597990612033755, 437.59999084472656],
                    [47.39762307307683, 8.597998617682606, 437.59999084472656],
                    [47.39762307307683, 8.597998617682606, 437.59999084472656],
                    [47.39762045489624, 8.597990612033755, 437.59999084472656],
                    [47.39794038259424, 8.59811018081382, 437],
                    [47.3979403427802, 8.598114154301584, 437],
                    [47.3979403427802, 8.598114154301584, 437],
                    [47.39794038259424, 8.59811018081382, 437],
                    [47.398170152446255, 8.598250309936702, 436.6999969482422],
                    [47.39817462232895, 8.598253056406975, 436.6999969482422],
                    [47.39817462232895, 8.598253056406975, 436.6999969482422],
                    [47.398170152446255, 8.598250309936702, 436.6999969482422],
                    [47.39837004500441, 8.598409661557525, 436.5],
                    [47.39837901154533, 8.59841250628233, 436.5],
                    [47.39837901154533, 8.59841250628233, 436.5],
                    [47.39837004500441, 8.598409661557525, 436.5],
                    [47.39846018515527, 8.598480512853712, 436.3999938964844],
                    [47.398410212481394, 8.598619853146374, 436.29998779296875],
                    [47.39841199782677, 8.598621217068285, 436.29998779296875],
                    [47.39841199782677, 8.598621217068285, 436.29998779296875],
                    [47.398410212481394, 8.598619853146374, 436.29998779296875],
                    [47.39829036197625, 8.59891002252698, 436.09999084472656],
                    [47.39829927543178, 8.59891816508025, 436.09999084472656],
                    [47.39829927543178, 8.59891816508025, 436.09999084472656],
                    [47.39829036197625, 8.59891002252698, 436.09999084472656],
                    [47.39814982120879, 8.599289825186133, 435.8999938964844],
                    [47.39815513743088, 8.599297889508307, 435.8999938964844],
                    [47.39815513743088, 8.599297889508307, 435.8999938964844],
                    [47.39814982120879, 8.599289825186133, 435.8999938964844],
                    [47.398010378237814, 8.599649777635932, 435.6999969482422],
                    [47.398013062775135, 8.599651161115617, 435.6999969482422],
                    [47.398013062775135, 8.599651161115617, 435.6999969482422],
                    [47.398010378237814, 8.599649777635932, 435.6999969482422],
                    [47.39791011647321, 8.599870156031102, 435.6999969482422],
                    [47.39791992912069, 8.599878318607807, 435.6999969482422],
                    [47.39791992912069, 8.599878318607807, 435.6999969482422],
                    [47.39791011647321, 8.599870156031102, 435.6999969482422],
                    [47.397880433127284, 8.599959594197571, 435.79998779296875],
                    [47.397810365771875, 8.599950117990375, 435.6999969482422],
                    [47.39777048956603, 8.599979718681425, 435.59999084472656],
                    [47.39776009134948, 8.600029833614826, 435.6999969482422],
                    [47.39768033125438, 8.600000274833292, 435.6999969482422],
                    [47.39768386189826, 8.600006975699216, 435.6999969482422],
                    [47.39768386189826, 8.600006975699216, 435.6999969482422],
                    [47.39768033125438, 8.600000274833292, 435.6999969482422],
                    [47.39745995029807, 8.599910685326904, 435.79998779296875],
                    [47.39746080967598, 8.599914678372443, 435.79998779296875],
                    [47.39746080967598, 8.599914678372443, 435.79998779296875],
                    [47.39745995029807, 8.599910685326904, 435.79998779296875],
                    [47.39719030633569, 8.599800151307136, 436.09999084472656],
                    [47.397197420941666, 8.599808255210519, 436.09999084472656],
                    [47.397197420941666, 8.599808255210519, 436.09999084472656],
                    [47.39719030633569, 8.599800151307136, 436.09999084472656],
                    [47.39683989644982, 8.599670636933297, 436.5],
                    [47.396847064374015, 8.599673442542553, 436.5],
                    [47.396847064374015, 8.599673442542553, 436.5],
                    [47.39683989644982, 8.599670636933297, 436.5],
                    [47.396580051630735, 8.599569592159241, 437.1999969482422],
                    [47.39658270962536, 8.599573624320328, 437.1999969482422],
                    [47.39658270962536, 8.599573624320328, 437.1999969482422],
                    [47.396580051630735, 8.599569592159241, 437.1999969482422],
                    [47.39637036877684, 8.599489512853324, 437.1999969482422],
                    [47.39637842285447, 8.599493662361056, 437.1999969482422],
                    [47.39637842285447, 8.599493662361056, 437.1999969482422],
                    [47.39637036877684, 8.599489512853324, 437.1999969482422],
                    [47.39625032572076, 8.599440531339496, 437.8999938964844],
                    [47.39629021775909, 8.599140684586018, 438.29998779296875],
                    [47.39629110391252, 8.599142028484493, 438.29998779296875],
                    [47.39629110391252, 8.599142028484493, 438.29998779296875],
                    [47.39629021775909, 8.599140684586018, 438.29998779296875],
                    [47.396349917165935, 8.598659778479487, 438.29998779296875],
                    [47.39635619916953, 8.598661240190268, 438.29998779296875],
                    [47.39635619916953, 8.598661240190268, 438.29998779296875],
                    [47.396349917165935, 8.598659778479487, 438.29998779296875],
                    [47.396410301327705, 8.59820008277893, 439.3999938964844],
                    [47.396417496027425, 8.598200239241123, 439.3999938964844],
                    [47.396417496027425, 8.598200239241123, 439.3999938964844],
                    [47.396410301327705, 8.59820008277893, 439.3999938964844],
                    [47.39645979460329, 8.597839504480362, 439.3999938964844],
                    [47.39646332548, 8.597846204880625, 439.3999938964844],
                    [47.39646332548, 8.597846204880625, 439.3999938964844],
                    [47.39645979460329, 8.597839504480362, 439.3999938964844],
                    [47.39648998528719, 8.597609655931592, 440],
                    [47.39661010913551, 8.5976506867446, 439.29998779296875],
                    [47.39661817625165, 8.59765351144597, 439.29998779296875],
                    [47.39661817625165, 8.59765351144597, 439.29998779296875],
                    [47.39661010913551, 8.5976506867446, 439.29998779296875],
                    [47.39685038314201, 8.597730100154877, 439.29998779296875],
                    [47.39685667841695, 8.597730237059295, 439.29998779296875],
                    [47.39685667841695, 8.597730237059295, 439.29998779296875],
                    [47.39685038314201, 8.597730100154877, 439.29998779296875],
                    [47.39710054942407, 8.597809729166329, 438.29998779296875],
                    [47.39710322092287, 8.597812436521053, 438.29998779296875],
                    [47.39710322092287, 8.597812436521053, 438.29998779296875],
                    [47.39710054942407, 8.597809729166329, 438.29998779296875],
                    [47.39725025789812, 8.597860678099096, 438.29998779296875],
                    [47.39725919789635, 8.597866171505302, 438.29998779296875],
                ],
                gpxUrl: '/uploads/trails_gpx/2019_Helsana-trailScharansGr\u00fcn_5c93a2f38695b.gpx',
                responsible: {
                    id: '7',
                    name: 'Giuseppe Torri',
                    email: 'giuseppe.torri@bluewin.ch',
                    phone: '079 575 92 42',
                },
            },
            {
                id: '144',
                type: TrailType.Yellow,
                name: 'Scharans yellow',
                startAddress: 'Lorem ipsum dolor sit amet!',
                finishAddress: 'Lorem ipsum dolor sit amet!',
                lengthMeters: 12191,
                climbMeters: 397,
                descentMeters: 397,
                isClosed: false,
                closedReason: '',
                special: '',
                waypoints: [
                    [46.7142252, 9.4603858, 781],
                    [46.7146364, 9.4600349, 782],
                    [46.715186, 9.4600117, 782],
                    [46.7156862, 9.4596362, 780],
                    [46.7162216, 9.4594402, 777],
                    [46.7168516, 9.4594376, 770],
                    [46.7169993, 9.459731, 769],
                    [46.7169947, 9.4599925, 769],
                    [46.7172539, 9.4595835, 766],
                    [46.7176796, 9.4594294, 767],
                    [46.7180264, 9.4591545, 766],
                    [46.7184924, 9.4592636, 765],
                    [46.7188556, 9.4590809, 763],
                    [46.7191948, 9.4592285, 765],
                    [46.719581, 9.4589174, 764],
                    [46.7206475, 9.458043, 760],
                    [46.7219971, 9.4572705, 757],
                    [46.7224679, 9.4566965, 749],
                    [46.7228172, 9.4562727, 743],
                    [46.7234093, 9.4559938, 736],
                    [46.7239903, 9.4557416, 730],
                    [46.724347, 9.455232, 727],
                    [46.7248104, 9.4548994, 725],
                    [46.7252627, 9.4546473, 728],
                    [46.7258989, 9.4543684, 731],
                    [46.7266026, 9.4535219, 729],
                    [46.7268071, 9.4533491, 732],
                    [46.7271712, 9.453215, 735],
                    [46.7279213, 9.4531614, 735],
                    [46.7286383, 9.4527322, 724],
                    [46.7295502, 9.4526196, 723],
                    [46.729951, 9.4525874, 723],
                    [46.7303776, 9.4525445, 723],
                    [46.7320454, 9.4525736, 727],
                    [46.7324329, 9.4525981, 729],
                    [46.7330212, 9.4525498, 730],
                    [46.7335507, 9.4523835, 732],
                    [46.7341904, 9.4510746, 728],
                    [46.7344919, 9.4503182, 726],
                    [46.7348854, 9.4497088, 724],
                    [46.7351808, 9.4492879, 725],
                    [46.7353044, 9.4488859, 726],
                    [46.735378, 9.4484943, 725],
                    [46.7361589, 9.4489317, 729],
                    [46.7369168, 9.4493265, 734],
                    [46.7372034, 9.4494026, 732],
                    [46.7373413, 9.4492376, 731],
                    [46.7374381, 9.4488486, 730],
                    [46.7376023, 9.4482958, 729],
                    [46.7379405, 9.4477755, 728],
                    [46.7383927, 9.4472712, 729],
                    [46.738628, 9.4477862, 733],
                    [46.7390653, 9.448425, 739],
                    [46.7394184, 9.4489557, 748],
                    [46.7397033, 9.4494959, 755],
                    [46.7396353, 9.450168, 759],
                    [46.7395728, 9.4506186, 760],
                    [46.7396537, 9.4508386, 763],
                    [46.7398081, 9.4510746, 767],
                    [46.7399662, 9.4512248, 770],
                    [46.7404991, 9.4513187, 776],
                    [46.740993, 9.4513765, 781],
                    [46.741215, 9.4515418, 782],
                    [46.7415396, 9.4516057, 785],
                    [46.741642, 9.4518196, 784],
                    [46.7417822, 9.4517827, 786],
                    [46.7419452, 9.4524853, 785],
                    [46.7421285, 9.4522959, 787],
                    [46.7423748, 9.4521087, 788],
                    [46.7426743, 9.4519628, 789],
                    [46.7429917, 9.4519329, 791],
                    [46.7434574, 9.4519528, 794],
                    [46.7441581, 9.4520182, 800],
                    [46.7444009, 9.4520273, 803],
                    [46.7446422, 9.4518203, 807],
                    [46.7449289, 9.4516805, 809],
                    [46.7449388, 9.452139, 814],
                    [46.745005, 9.4524688, 821],
                    [46.7451525, 9.4527754, 830],
                    [46.7453727, 9.4530454, 838],
                    [46.7455491, 9.4532483, 842],
                    [46.7456321, 9.4536441, 851],
                    [46.7457128, 9.4541708, 860],
                    [46.7458228, 9.4545676, 865],
                    [46.7458406, 9.4548994, 869],
                    [46.7462229, 9.4549155, 873],
                    [46.7464645, 9.4549189, 875],
                    [46.746645, 9.4548863, 877],
                    [46.7468404, 9.4547385, 881],
                    [46.7469654, 9.4545937, 883],
                    [46.7470863, 9.454353, 882],
                    [46.7472888, 9.4540988, 883],
                    [46.7475189, 9.4538063, 873],
                    [46.7476577, 9.453589, 869],
                    [46.7478411, 9.4533995, 869],
                    [46.7481159, 9.4531184, 864],
                    [46.7483769, 9.4530487, 866],
                    [46.7487018, 9.4530651, 863],
                    [46.7489524, 9.4531399, 859],
                    [46.7490843, 9.453315, 861],
                    [46.7491258, 9.4535129, 866],
                    [46.7491673, 9.4537109, 871],
                    [46.7493006, 9.4538075, 871],
                    [46.7494366, 9.4537471, 866],
                    [46.7496156, 9.4535583, 858],
                    [46.7498398, 9.4533545, 849],
                    [46.7500945, 9.4531826, 843],
                    [46.750608, 9.4531077, 844],
                    [46.7512622, 9.4531184, 850],
                    [46.7516188, 9.4529736, 849],
                    [46.7520231, 9.4528824, 851],
                    [46.7524856, 9.4528137, 852],
                    [46.7528721, 9.4526893, 856],
                    [46.753089, 9.452287, 856],
                    [46.753269, 9.4520563, 856],
                    [46.753519, 9.4514018, 856],
                    [46.7539087, 9.4512042, 859],
                    [46.7541622, 9.4510746, 861],
                    [46.7545202, 9.451227, 868],
                    [46.7546988, 9.4513643, 870],
                    [46.7548458, 9.4517237, 873],
                    [46.7549817, 9.4516432, 872],
                    [46.7550277, 9.451534, 872],
                    [46.7551508, 9.4512141, 873],
                    [46.7552941, 9.45108, 877],
                    [46.7553768, 9.4511281, 878],
                    [46.755533, 9.451198, 881],
                    [46.7556641, 9.451165, 886],
                    [46.7557826, 9.4510778, 889],
                    [46.755921, 9.4508866, 893],
                    [46.7564702, 9.4513106, 917],
                    [46.7567257, 9.4511785, 916],
                    [46.7570469, 9.4508239, 900],
                    [46.7572071, 9.4504109, 892],
                    [46.7573536, 9.4497617, 886],
                    [46.7575581, 9.448843, 855],
                    [46.7578116, 9.4485158, 852],
                    [46.7579586, 9.4481885, 851],
                    [46.7582269, 9.4473678, 846],
                    [46.7585136, 9.4466275, 841],
                    [46.7588333, 9.4460642, 838],
                    [46.7593147, 9.4454741, 831],
                    [46.7596565, 9.4449431, 820],
                    [46.7598733, 9.4446963, 816],
                    [46.7601159, 9.4445837, 817],
                    [46.7601012, 9.4443744, 814],
                    [46.7599284, 9.4444013, 812],
                    [46.7597006, 9.4445246, 813],
                    [46.7592449, 9.4442886, 809],
                    [46.7587047, 9.4438219, 804],
                    [46.758124, 9.4440472, 805],
                    [46.7575948, 9.444176, 804],
                    [46.7570509, 9.4441867, 801],
                    [46.7563857, 9.4444442, 797],
                    [46.7550823, 9.4448588, 801],
                    [46.7542871, 9.4446748, 801],
                    [46.7536366, 9.4446373, 804],
                    [46.7532249, 9.4448358, 802],
                    [46.7528721, 9.4451255, 800],
                    [46.7524899, 9.4451737, 797],
                    [46.7521113, 9.4453025, 795],
                    [46.7515048, 9.4456404, 792],
                    [46.7509939, 9.4461769, 793],
                    [46.7507219, 9.446429, 795],
                    [46.7503103, 9.446708, 791],
                    [46.7499648, 9.4470459, 789],
                    [46.7493325, 9.4479176, 790],
                    [46.7488314, 9.4482655, 787],
                    [46.7485276, 9.4486874, 785],
                    [46.7481931, 9.4494116, 787],
                    [46.7478388, 9.4499565, 787],
                    [46.7476087, 9.4504094, 783],
                    [46.747355, 9.4511443, 782],
                    [46.7471198, 9.4515198, 783],
                    [46.7470169, 9.451611, 782],
                    [46.7467118, 9.4516915, 780],
                    [46.7462964, 9.4519061, 787],
                    [46.7459104, 9.4517344, 795],
                    [46.745484, 9.4516164, 802],
                    [46.7450638, 9.4516855, 809],
                    [46.7449253, 9.4516808, 809],
                    [46.7446459, 9.4518203, 807],
                    [46.7444023, 9.4520226, 803],
                    [46.7441449, 9.4520173, 800],
                    [46.7434575, 9.4519475, 794],
                    [46.742999, 9.4519275, 791],
                    [46.7426672, 9.4519583, 789],
                    [46.7423657, 9.4521085, 788],
                    [46.7421278, 9.4522923, 787],
                    [46.7419393, 9.4524786, 785],
                    [46.7419109, 9.4526947, 786],
                    [46.7417746, 9.4529764, 788],
                    [46.7415617, 9.4532365, 788],
                    [46.7413999, 9.4536388, 788],
                    [46.7410286, 9.4539446, 784],
                    [46.7405507, 9.4542933, 780],
                    [46.7402272, 9.4545829, 779],
                    [46.7399956, 9.4546098, 779],
                    [46.7389699, 9.4541699, 783],
                    [46.7383993, 9.4545518, 781],
                    [46.7381023, 9.4546205, 781],
                    [46.738014, 9.4551086, 784],
                    [46.7380661, 9.4555864, 785],
                    [46.7375876, 9.4558007, 784],
                    [46.7371574, 9.4559133, 784],
                    [46.7368585, 9.4561956, 788],
                    [46.7362493, 9.4565248, 791],
                    [46.7356157, 9.4567643, 791],
                    [46.7352553, 9.45679, 790],
                    [46.7351153, 9.4570727, 793],
                    [46.7350231, 9.4572001, 794],
                    [46.7344309, 9.4576099, 794],
                    [46.7339785, 9.45775, 789],
                    [46.7334882, 9.4580644, 787],
                    [46.7331793, 9.4580913, 783],
                    [46.7329806, 9.4582099, 782],
                    [46.7326352, 9.458456, 781],
                    [46.7323447, 9.4585794, 780],
                    [46.7319851, 9.458526, 779],
                    [46.7314006, 9.4585041, 781],
                    [46.7308768, 9.4586153, 789],
                    [46.730541, 9.4587729, 792],
                    [46.7302967, 9.4584185, 789],
                    [46.7298286, 9.4583536, 788],
                    [46.7293076, 9.4581825, 785],
                    [46.7288124, 9.4583155, 790],
                    [46.7283432, 9.4583895, 789],
                    [46.7278882, 9.4581556, 781],
                    [46.727598, 9.4582962, 781],
                    [46.7271034, 9.4582777, 776],
                    [46.7263164, 9.4585099, 776],
                    [46.7255758, 9.458155, 777],
                    [46.7253178, 9.4580323, 774],
                    [46.7247626, 9.4580162, 771],
                    [46.7239977, 9.4578981, 770],
                    [46.7237155, 9.4580199, 771],
                    [46.7235417, 9.4583112, 775],
                    [46.723207, 9.4583863, 774],
                    [46.7214161, 9.458794, 773],
                    [46.7205188, 9.458853, 769],
                    [46.7198752, 9.4589229, 765],
                    [46.719581, 9.4589227, 764],
                    [46.7191948, 9.4592392, 765],
                    [46.7188517, 9.4590822, 763],
                    [46.7184876, 9.4592646, 765],
                    [46.7180242, 9.459152, 766],
                    [46.7176675, 9.4594309, 767],
                    [46.7172519, 9.4595704, 766],
                    [46.7169871, 9.4599995, 769],
                    [46.7169908, 9.4597313, 769],
                    [46.7168473, 9.4594309, 770],
                    [46.7162147, 9.4594363, 777],
                    [46.7156825, 9.4596362, 780],
                    [46.715186, 9.4600117, 782],
                    [46.7146295, 9.4600371, 782],
                    [46.7142139, 9.4603858, 781],
                ],
                gpxUrl: '/uploads/trails_gpx/scharans_gelb_58541687e7292.gpx',
                responsible: {
                    id: '7',
                    name: 'Giuseppe Torri',
                    email: 'giuseppe.torri@bluewin.ch',
                    phone: '079 575 92 42',
                },
            },
        ],
    },
];

const trailMock = {
    id: '39',
    type: TrailType.Green,
    name: 'Scharans green',
    startAddress: 'Carutt 58\u003Cbr /\u003E\r\n7412 Scharans',
    finishAddress: 'Carutt 58\u003Cbr /\u003E\r\n7412 Scharans',
    lengthMeters: 8324,
    climbMeters: 197,
    additionalInformation: 'Kinderwagen tauglich\u003Cbr /\u003E\r\nRollstuhl tauglich\u003Cbr /\u003E\r\nMountainbike tauglich\u003Cbr /\u003E\r\nIm Winter begehbar',
    descentMeters: 196,
    isClosed: false,
    closedReason: '',
    special: '',
    waypoints: [
        [47.39735060953535, 8.597899954766035, 437.59999084472656],
        [47.39734980324283, 8.59789066389203, 437.59999084472656],
        [47.39762045489624, 8.597990612033755, 437.59999084472656],
        [47.39762307307683, 8.597998617682606, 437.59999084472656],
        [47.39762307307683, 8.597998617682606, 437.59999084472656],
        [47.39762045489624, 8.597990612033755, 437.59999084472656],
        [47.39794038259424, 8.59811018081382, 437],
        [47.3979403427802, 8.598114154301584, 437],
        [47.3979403427802, 8.598114154301584, 437],
        [47.39794038259424, 8.59811018081382, 437],
        [47.398170152446255, 8.598250309936702, 436.6999969482422],
        [47.39817462232895, 8.598253056406975, 436.6999969482422],
        [47.39817462232895, 8.598253056406975, 436.6999969482422],
        [47.398170152446255, 8.598250309936702, 436.6999969482422],
        [47.39837004500441, 8.598409661557525, 436.5],
        [47.39837901154533, 8.59841250628233, 436.5],
        [47.39837901154533, 8.59841250628233, 436.5],
        [47.39837004500441, 8.598409661557525, 436.5],
        [47.39846018515527, 8.598480512853712, 436.3999938964844],
        [47.398410212481394, 8.598619853146374, 436.29998779296875],
        [47.39841199782677, 8.598621217068285, 436.29998779296875],
        [47.39841199782677, 8.598621217068285, 436.29998779296875],
        [47.398410212481394, 8.598619853146374, 436.29998779296875],
        [47.39829036197625, 8.59891002252698, 436.09999084472656],
        [47.39829927543178, 8.59891816508025, 436.09999084472656],
        [47.39829927543178, 8.59891816508025, 436.09999084472656],
        [47.39829036197625, 8.59891002252698, 436.09999084472656],
        [47.39814982120879, 8.599289825186133, 435.8999938964844],
        [47.39815513743088, 8.599297889508307, 435.8999938964844],
        [47.39815513743088, 8.599297889508307, 435.8999938964844],
        [47.39814982120879, 8.599289825186133, 435.8999938964844],
        [47.398010378237814, 8.599649777635932, 435.6999969482422],
        [47.398013062775135, 8.599651161115617, 435.6999969482422],
        [47.398013062775135, 8.599651161115617, 435.6999969482422],
        [47.398010378237814, 8.599649777635932, 435.6999969482422],
        [47.39791011647321, 8.599870156031102, 435.6999969482422],
        [47.39791992912069, 8.599878318607807, 435.6999969482422],
        [47.39791992912069, 8.599878318607807, 435.6999969482422],
        [47.39791011647321, 8.599870156031102, 435.6999969482422],
        [47.397880433127284, 8.599959594197571, 435.79998779296875],
        [47.397810365771875, 8.599950117990375, 435.6999969482422],
        [47.39777048956603, 8.599979718681425, 435.59999084472656],
        [47.39776009134948, 8.600029833614826, 435.6999969482422],
        [47.39768033125438, 8.600000274833292, 435.6999969482422],
        [47.39768386189826, 8.600006975699216, 435.6999969482422],
        [47.39768386189826, 8.600006975699216, 435.6999969482422],
        [47.39768033125438, 8.600000274833292, 435.6999969482422],
        [47.39745995029807, 8.599910685326904, 435.79998779296875],
        [47.39746080967598, 8.599914678372443, 435.79998779296875],
        [47.39746080967598, 8.599914678372443, 435.79998779296875],
        [47.39745995029807, 8.599910685326904, 435.79998779296875],
        [47.39719030633569, 8.599800151307136, 436.09999084472656],
        [47.397197420941666, 8.599808255210519, 436.09999084472656],
        [47.397197420941666, 8.599808255210519, 436.09999084472656],
        [47.39719030633569, 8.599800151307136, 436.09999084472656],
        [47.39683989644982, 8.599670636933297, 436.5],
        [47.396847064374015, 8.599673442542553, 436.5],
        [47.396847064374015, 8.599673442542553, 436.5],
        [47.39683989644982, 8.599670636933297, 436.5],
        [47.396580051630735, 8.599569592159241, 437.1999969482422],
        [47.39658270962536, 8.599573624320328, 437.1999969482422],
        [47.39658270962536, 8.599573624320328, 437.1999969482422],
        [47.396580051630735, 8.599569592159241, 437.1999969482422],
        [47.39637036877684, 8.599489512853324, 437.1999969482422],
        [47.39637842285447, 8.599493662361056, 437.1999969482422],
        [47.39637842285447, 8.599493662361056, 437.1999969482422],
        [47.39637036877684, 8.599489512853324, 437.1999969482422],
        [47.39625032572076, 8.599440531339496, 437.8999938964844],
        [47.39629021775909, 8.599140684586018, 438.29998779296875],
        [47.39629110391252, 8.599142028484493, 438.29998779296875],
        [47.39629110391252, 8.599142028484493, 438.29998779296875],
        [47.39629021775909, 8.599140684586018, 438.29998779296875],
        [47.396349917165935, 8.598659778479487, 438.29998779296875],
        [47.39635619916953, 8.598661240190268, 438.29998779296875],
        [47.39635619916953, 8.598661240190268, 438.29998779296875],
        [47.396349917165935, 8.598659778479487, 438.29998779296875],
        [47.396410301327705, 8.59820008277893, 439.3999938964844],
        [47.396417496027425, 8.598200239241123, 439.3999938964844],
        [47.396417496027425, 8.598200239241123, 439.3999938964844],
        [47.396410301327705, 8.59820008277893, 439.3999938964844],
        [47.39645979460329, 8.597839504480362, 439.3999938964844],
        [47.39646332548, 8.597846204880625, 439.3999938964844],
        [47.39646332548, 8.597846204880625, 439.3999938964844],
        [47.39645979460329, 8.597839504480362, 439.3999938964844],
        [47.39648998528719, 8.597609655931592, 440],
        [47.39661010913551, 8.5976506867446, 439.29998779296875],
        [47.39661817625165, 8.59765351144597, 439.29998779296875],
        [47.39661817625165, 8.59765351144597, 439.29998779296875],
        [47.39661010913551, 8.5976506867446, 439.29998779296875],
        [47.39685038314201, 8.597730100154877, 439.29998779296875],
        [47.39685667841695, 8.597730237059295, 439.29998779296875],
        [47.39685667841695, 8.597730237059295, 439.29998779296875],
        [47.39685038314201, 8.597730100154877, 439.29998779296875],
        [47.39710054942407, 8.597809729166329, 438.29998779296875],
        [47.39710322092287, 8.597812436521053, 438.29998779296875],
        [47.39710322092287, 8.597812436521053, 438.29998779296875],
        [47.39710054942407, 8.597809729166329, 438.29998779296875],
        [47.39725025789812, 8.597860678099096, 438.29998779296875],
        [47.39725919789635, 8.597866171505302, 438.29998779296875],
    ],
    gpxUrl: '/uploads/trails_gpx/2019_Helsana-trailScharansGr\u00fcn_5c93a2f38695b.gpx',
    responsible: {
        id: '7',
        name: 'Giuseppe Torri',
        email: 'giuseppe.torri@bluewin.ch',
        phone: '079 575 92 42',
    },
};

const attractionsMock = [
    {
        id: '622ae996-45a0-4b31-9434-0cada3cc04c',
        name: 'Torre di Redde',
        phone: '+41 91 936 03 76',
        websiteUrl: 'http://areaviva.ch/it/protagonisti/torre-di-redde',
        description: 'Der Torre di Redde (Turm von Redde) ist mittelalterlichen Ursprungs und steht im Wald südlich des Dorfes Vaglio im Kanton Tessin. Der Wohnturm steht auf einer Höhe von 619 m ü. M. und wird auch «Torre di San Clemente» genannt.\r\n',
        coordinates: {
            lat: 47.39829036197625,
            lng: 8.59891002252698,
        },
        fotoUrl: '/uploads/attractions/5bea9ccd5c7ef5bea9ccd5c8ad.jpg',
        isTopAttraction: false,
        category: {
            id: 'fa075638-1493-4081-b643-21224db6a085',
            name: 'Antike Stätte',
            iconWebPlainUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/69b86e5f-1c63-4cab-bb68-59c06fe0b539.svg',
            iconWebMapUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/e9a12e84-0df7-4a5d-897e-ee879153cb7e.svg',
            iconWebMapActiveUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/0541aec2-22aa-48db-8d83-19491a3f5bc0.svg',
        },
    },
    {
        id: '622ae996-45a0-4b31-9434-0cada3cc04',
        name: 'Torre di Redde',
        phone: '+41 91 936 03 76',
        websiteUrl: 'http://areaviva.ch/it/protagonisti/torre-di-redde',
        description: 'Der Torre di Redde (Turm von Redde) ist mittelalterlichen Ursprungs und steht im Wald südlich des Dorfes Vaglio im Kanton Tessin. Der Wohnturm steht auf einer Höhe von 619 m ü. M. und wird auch «Torre di San Clemente» genannt.\r\n',
        coordinates: {
            lat: 47.39776009134948,
            lng: 8.600029833614826,
        },
        fotoUrl: '/uploads/attractions/5bea9ccd5c7ef5bea9ccd5c8ad.jpg',
        isTopAttraction: false,
        category: {
            id: 'fa075638-1493-4081-b643-21224db6a085',
            name: 'Antike Stätte',
            iconWebPlainUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/69b86e5f-1c63-4cab-bb68-59c06fe0b539.svg',
            iconWebMapUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/e9a12e84-0df7-4a5d-897e-ee879153cb7e.svg',
            iconWebMapActiveUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/0541aec2-22aa-48db-8d83-19491a3f5bc0.svg',
        },
    },
    {
        id: '622ae996-45a0-4b31-9434-0cada3cc',
        name: 'Torre di Redde',
        phone: '+41 91 936 03 76',
        websiteUrl: 'http://areaviva.ch/it/protagonisti/torre-di-redde',
        description: 'Der Torre di Redde (Turm von Redde) ist mittelalterlichen Ursprungs und steht im Wald südlich des Dorfes Vaglio im Kanton Tessin. Der Wohnturm steht auf einer Höhe von 619 m ü. M. und wird auch «Torre di San Clemente» genannt.\r\n',
        coordinates: {
            lat: 47.39685667841695,
            lng: 8.597730237059295,
        },
        fotoUrl: '/uploads/attractions/5bea9ccd5c7ef5bea9ccd5c8ad.jpg',
        isTopAttraction: false,
        category: {
            id: 'fa075638-1493-4081-b643-21224db6a085',
            name: 'Antike Stätte',
            iconWebPlainUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/69b86e5f-1c63-4cab-bb68-59c06fe0b539.svg',
            iconWebMapUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/e9a12e84-0df7-4a5d-897e-ee879153cb7e.svg',
            iconWebMapActiveUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/0541aec2-22aa-48db-8d83-19491a3f5bc0.svg',
        },
    },
    {
        id: '622ae996-45a0-4b31-9434-0cada3c',
        name: 'Torre di Redde',
        phone: '+41 91 936 03 76',
        websiteUrl: 'http://areaviva.ch/it/protagonisti/torre-di-redde',
        description: 'Der Torre di Redde (Turm von Redde) ist mittelalterlichen Ursprungs und steht im Wald südlich des Dorfes Vaglio im Kanton Tessin. Der Wohnturm steht auf einer Höhe von 619 m ü. M. und wird auch «Torre di San Clemente» genannt.\r\n',
        coordinates: {
            lat: 47.39683989644982,
            lng: 8.599670636933297,
        },
        fotoUrl: '/uploads/attractions/5bea9ccd5c7ef5bea9ccd5c8ad.jpg',
        isTopAttraction: false,
        category: {
            id: 'fa075638-1493-4081-b643-21224db6a085',
            name: 'Antike Stätte',
            iconWebPlainUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/69b86e5f-1c63-4cab-bb68-59c06fe0b539.svg',
            iconWebMapUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/e9a12e84-0df7-4a5d-897e-ee879153cb7e.svg',
            iconWebMapActiveUrl: 'https://api.helsana-integration.ch/hplus-trails/api/trails/v1/assets?assetpath=attractioncategoryicons/0541aec2-22aa-48db-8d83-19491a3f5bc0.svg',
        },
    },
];

const mockLocations = [{
        "id": "21f9397e-9a63-41a6-b44e-29c9341db2b1",
        "name": "Aarau AG",
        "postalCode": "5000",
        "city": "Aarau",
        "trailsCount": 2,
        "closedTrailsCount": 0,
        "coordinates": {
            "lat": 47.3927,
            "lng": 8.03152
        },
        longestTrailLengthMeters: 1000,
        shortestTrailLengthMeters: 100
    },
    {
        "id": "50e4c75d-7cb6-4500-9cc4-27a189d910c0",
        "name": "Aarberg - Lyss BE",
        "postalCode": "3250",
        "city": "Lyss BE",
        "trailsCount": 3,
        "closedTrailsCount": 0,
        "coordinates": {
            "lat": 47.0498,
            "lng": 7.27643
        },
        longestTrailLengthMeters: 1000,
        shortestTrailLengthMeters: 100
    },
    {
        "id": "1fc0544f-6e0e-45aa-8e04-4915ccb4f590",
        "name": "Alle JU",
        "postalCode": "2942",
        "city": "Alle JU",
        "trailsCount": 3,
        "closedTrailsCount": 0,
        "coordinates": {
            "lat": 47.4364,
            "lng": 7.11333
        },
        longestTrailLengthMeters: 1000,
        shortestTrailLengthMeters: 100
    },
    {
        "id": "48aefb39-73ab-43b4-a3d9-94a4befeffab",
        "name": "Alt St. Johann SG",
        "postalCode": "9656",
        "city": "Alt St. Johann SG",
        "trailsCount": 5,
        "closedTrailsCount": 0,
        "coordinates": {
            "lat": 47.1933,
            "lng": 9.28729
        }
    },
    {
        "id": "a820c3b0-f28a-4c57-8536-9c2fef8a19ac",
        "name": "Altst\u00E4tten SG",
        "postalCode": "9450",
        "city": "Altst\u00E4tten SG",
        "trailsCount": 3,
        "closedTrailsCount": 3,
        "coordinates": {
            "lat": 47.385,
            "lng": 9.54559
        },
        longestTrailLengthMeters: 1000
    },
    {
        "id": "db47da6a-6c9c-49f3-8121-e5397dfa85f4",
        "name": "Alvi Baltenswil",
        "postalCode": "8303",
        "city": "Baltenswil",
        "trailsCount": 1,
        "closedTrailsCount": 0,
        "coordinates": {
            "lat": 47.431418676395,
            "lng": 8.64486616943032
        },
        shortestTrailLengthMeters: 100
    },
];

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, ChipButtonComponent, DownloadLinkComponent, ElevationProfileComponent, GoogleMapsButtonComponent, GoogleMapsComponent, GoogleMapsGestureHandling, GoogleMapsService, LabelComponent, LinkWithIconComponent, LinkWrapperComponent, ListComponent, ListItemComponent, MapBarComponent, MapBarMobileComponent, PreviewPanelComponent, ResetLocationButtonDirective, Tab, TabBarComponent, TabComponent, TitleComponent, TitleContentComponent, TitleSize, TitleType, UiAutocompleteComponent, UiCheckboxComponent, UiFormBaseComponent, UiInputComponent, UiOverlayHeaderComponent, UiSelectComponent, WarningLabelComponent, attractionsMock, mockLocations, trailMock, trailsLocationMock };
